import {
  API_CALL,
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
  CHECKOUT_ADD_ITEM,
  CHECKOUT_SET_EXPERIENCES_PASSPORT_RECONCILIATION,
  CHECKOUT_APPLY_PARTNERSHIP_STATUS,
  CHECKOUT_APPLY_PROMO_CODE,
  CHECKOUT_APPLY_PROMO_CODE_FAILED,
  CHECKOUT_APPLY_VELOCITY_BURN,
  CHECKOUT_CLEAR_CART,
  CHECKOUT_FETCHING_PROMO_CODE,
  CHECKOUT_HIDE_PROMO_CORPORATE_BENEFITS,
  CHECKOUT_INITIALISE,
  CHECKOUT_SET_MODE,
  CHECKOUT_MODIFY_FLIGHT_SEARCH_VIEW,
  CHECKOUT_PROCESS_CANCEL,
  CHECKOUT_PROCESS_FAILURE,
  CHECKOUT_PROCESS_START,
  CHECKOUT_PROCESS_SUCCESS,
  CHECKOUT_REMOVE_ITEM,
  CHECKOUT_RESET_PROMO_CODE,
  CHECKOUT_RESTORE_CART,
  CHECKOUT_INITIALISE_FORM,
  CHECKOUT_RESTORE_PAYMENT,
  CHECKOUT_SET_FORM,
  CHECKOUT_CLEAR_TRAVELLER_FORM,
  CHECKOUT_SET_RESTORE_CART_STATUS,
  CHECKOUT_TOGGLE_DEV_TOOLS,
  CHECKOUT_SET_POST_PURCHASE,
  CHECKOUT_ADD_ROOMS_TO_BE_CONNECTED,
  CHECKOUT_SET_GUEST_CHECKOUT_MODE,
  CHECKOUT_SET_GUEST_CHECKOUT_VOUCHER_DISABLED,
  CHECKOUT_SET_SPECIAL_REQUEST,
  CHECKOUT_SET_VELOCITY_BURN_MODAL_STATUS,
  CHECKOUT_SET_VELOCITY_SSO,
  CHECKOUT_SHOW_PROMO_CORPORATE_BENEFITS,
  CHECKOUT_TOGGLE_CREDIT,
  CHECKOUT_SET_CLASSIC_REWARDS,
  CHECKOUT_UPDATE_ARRIVAL_FLIGHT_NUMBER,
  CHECKOUT_UPDATE_BUNDLE_ITEM_PRICING,
  CHECKOUT_UPDATE_CS_DEPOSIT_OVERRIDE,
  CHECKOUT_UPDATE_EXPERIENCE_ITEM,
  CHECKOUT_UPDATE_HOTEL_ITEM_PRICING,
  CHECKOUT_UPDATE_ITEM,
  CHECKOUT_REPLACE_INSURANCE_SELECTION,
  CHECKOUT_UPDATE_PAYMENT_SELECTION,
  CHECKOUT_SAVE_GROUP_PAYMENT,
  CHECKOUT_CLEAR_GROUP_PAYMENT,
  CHECKOUT_SELECT_STATIC_SCHEDULE_OPTION,
  CHECKOUT_SET_PAYMENT_SCHEDULE_BALANCE_TYPE,
  CHECKOUT_SET_PAYMENT_SCHEDULE_FULL_BALANCE_ONLY,
  CHECKOUT_SET_DYNAMIC_PAYMENT_SCHEDULE_FREQUENCY,
  CHECKOUT_SET_SAVE_CARD_AS_LUX_PLUS_BACKUP,
  CHECKOUT_SET_PAY_LUX_PLUS_RENEWAL_WITH_POINTS,
  SET_TERMINAL_READER_ID,
  CHECKOUT_SHOW_PROMO_FRIENDS_AND_FAMILY,
  CHECKOUT_HIDE_PROMO_FRIENDS_AND_FAMILY,
  CHECKOUT_CLEAR_VELOCITY_BURN,
  CHECKOUT_CLEAR_VELOCITY_MEMBER_DETAILS,
  CHECKOUT_SET_MULTI_CART_ITEM_MODE,
  CHECKOUT_REMOVE_TRAVELLER_SCHEMA,
  CHECKOUT_SET_MERCHANT_FEE_PAYMENT_TYPE,
  CHECKOUT_SET_SPLIT_MERCHANT_FEE_AMOUNT,
  CHECKOUT_SET_INLINE_SPLIT_ACTIVE,
  CHECKOUT_SET_SPLIT_CARD_LEGS,
  CHECKOUT_SET_SPLIT_NEW_CARD_DETAILS,
  CHECKOUT_RESET_FORM,
  CHECKOUT_CLEAR_CART_RESTORE_PRICE,
  CHECKOUT_AGENT_BOOKING_DETAILS,
  CHECKOUT_SET_LUXPLUS_UPSELL_DATA,
  CHECKOUT_SET_LUXPLUS_UPSELL_DECISION,
  CHECKOUT_SET_STRIPE_PAYMENT_METHOD,
  CHECKOUT_SET_DISPLAYED_PAYMENT_METHOD,
  CHECKOUT_ADD_ARRIVAL_DETAILS,
  CHECKOUT_SET_ARRIVAL_DETAILS_TIME,
  CHECKOUT_SET_ARRIVAL_DETAILS_FLIGHT_NUMBER,
  ACTIVATE_REBOOKING,
  ACTIVATE_PAYMENT_SCHEDULE_REBOOKING,
  CLEAR_PAYMENT_SCHEDULE_REBOOKING,
  CHECKOUT_SET_PAYTO_BANK,
  CHECKOUT_SET_COMMS_RESUBSCRIBE,
  CHECKOUT_FETCHING_PAYMENT_LINK,
  CHECKOUT_SET_PAYMENT_LINK,
  CHECKOUT_FETCHING_PAYMENT_LINK_FAILED,
  CHECKOUT_SET_VOUCHER_IDS,
  CHECKOUT_CLEAR_VOUCHER_IDS,
  CHECKOUT_SET_AGENT_REQUEST_3DS,
  CHECKOUT_SET_ORDER_ID,
  CHECKOUT_RESET_COMMISSION,
  CHECKOUT_TOGGLE_LOYALTY_SIGNUP,
  CHECKOUT_REMOVE_ROOMS_TO_BE_CONNECTED,
  CHECKOUT_SET_HAS_CAR_HIRE_INTENTION,
  CHECKOUT_SET_AGENT_HUB_PAYMENT_SETUP,
  SET_BEDBANK_SESSION,
  CHECKOUT_CLEAR_RESTORED_PROMO_CODE,
  CHECKOUT_CLEAR_RESTORED_USE_CREDIT,
  CHECKOUT_TOGGLE_GIFT_CARD,
  CHECKOUT_RESTORE_LOYALTY_UPDATE_POINTS_TO_BURN,
  SET_PAYPAL_PAYMENT_TYPE,
  CHECKOUT_TOGGLE_FAILED_ITEMS,
  CHECKOUT_LOYALTY_UPDATE_POINTS_TO_BURN,
  CHECKOUT_SET_DELIVERY_FORM,
  CHECKOUT_VALIDATE_OFFER_DISCOUNT,
  CHECKOUT_SET_CHARTER_UPGRADE,
  CHECKOUT_SET_FLIGHT_SEATS,
  CHECKOUT_DISCARD_FLIGHT_SEATS,
  CHECKOUT_SET_FLIGHT_BAGGAGE,
  CHECKOUT_DISCARD_FLIGHT_BAGGAGE,
  CHECKOUT_SET_PAYMENT_PROGRESS_STEP,
  CHECKOUT_SET_PAYMENT_PROGRESS_FAILED,
} from 'actions/actionConstants'
import { setGuestCheckoutSessionCartId } from 'lib/checkout/guestCheckout'
import {
  CHECKOUT_FETCH_BEDBANK_EXISTING_ORDER,
  CHECKOUT_INIT_BEDBANK_CHANGE_DATES_SESSION,
  CHECKOUT_REQUEST_CORPORATE_BENEFITS_PROMO,
  CHECKOUT_REQUEST_FRIENDS_AND_FAMILY_PROMO,
  FETCH_BEDBANK_OFFER,
  FETCH_BEDBANK_OFFERS_RATES, FETCH_COMMMISSION_PROMO, FETCH_TRAVELLER_FORM_SCHEMA,
  FETCH_VELOCITY_MEMBER_DETAILS,
  LOG_PAYMENT_EVENT,
  UPDATE_BEDBANK_SESSION,
  CREATE_STRIPE_PAYMENT_METHOD,
  CHECKOUT_CREATE_CART_QUOTE,
  CHECKOUT_UPDATE_CART_QUOTE,
  FETCH_COMMISSION_PROMO_CODE,
} from 'actions/apiActionConstants'
import { SOURCE_TYPES } from 'constants/source'
import type { Bedbank } from '@luxuryescapes/contract-svc-bedbank'
import type { CreateReservationEnquiryProps } from 'api/bedbank'
import type { ApiActionResult } from 'middlewares/apiMiddleware'
import { enquiry } from 'api/bedbank'
import { getRatesForBedbankOffer, getRatesForBedbankOffers } from 'api/bedbankRates'
import { getOfferById } from 'api/offer'
import type { RestrictedPromoRequestData } from 'api/promo'
import {
  getPromoV2,
  getReferralPromo,
  registerCorporateBenefits,
  registerFriendsAndFamily,
} from 'api/promo'
import { retrieveTravellerDetailsForm } from 'api/traveller'
import { getFriendsAndFamilyRequesterOffer } from 'checkout/selectors/experienceSelectors'
import { getVelocityMemberProfile, type VelocityMemberProfile } from 'api/velocity'
import { getIsLuxPlusMemberRedeemingBenefitSchemaRequest, getTravellerFormSchemaRequest, getTravellerFormSchemaRequestKey } from 'checkout/selectors/request/travellerSchema'
import getCheckoutTotalsView from 'checkout/selectors/payment/getCheckoutTotalsView'
import getCreditPayableAmount from 'checkout/selectors/payment/getCreditPayableAmount'
import { checkoutAccommodationOfferView } from 'checkout/selectors/view/accommodation'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import config from 'constants/config'
import { LUXURY_ESCAPES } from 'constants/brands'
import { OFFER_TYPE_BED_BANK } from 'constants/offer'
import { VIRGIN_VELOCITY_BURN_MINIMUM } from 'constants/partnerships'
import { EMAIL_PATTERN } from 'constants/regularExpressions'
import type {
  PAYLATER_PAYMENT_TYPE,
  PaymentMethod, PAYPAL_PAYMENT_TYPE,
} from 'constants/payment'
import {
  CREDIT_PAYMENT_TYPE,
  PAYMENT_OPTIONS,
  PROMO_PAYMENT_TYPE,
  SECURE_PAYMENT_OPTIONS,
  STRIPE_PAYMENT_TYPE,
} from 'constants/payment'
import equal from 'fast-deep-equal'
import { deduceGenderFromTitle } from 'lib/tours/tourUtils'
import { arrayToMap, fillArray, groupBy, isNonEmptyArray, sum } from 'lib/array/arrayUtils'
import type { ExperienceDetails } from 'lib/checkout/experiences/cart'
import { paymentMethodsToString } from 'lib/payment/paymentUtils'
import { getCurrentIntl } from 'i18n/util/currentIntl'
import moment from 'moment/moment'
import type { AppDispatch } from '../store'
import { getBedbankRateKey } from 'lib/hotels/getBedbankRateKey'
import { genericOrderErrorModalOpen, bedbankHotelPriceChangeModalOpen, bedbankSoldOutModalOpen, loyaltyUpgradeRejectedModalOpen, showSecurePaymentModal } from './UiActions'
import { getPaymentMethodAvailability } from 'checkout/selectors/payment/paymentType'
import { getCartFlightJourneys } from 'checkout/selectors/payment/flights'
import { getIsCharterFlightCheckout } from 'checkout/selectors/view/flights'
import { EMPLOYEE20_PROMO_CODE } from 'constants/promotion'
import { sortTravellers } from 'checkout/lib/utils/form/sortTravellers'
import type { SnowplowEvent } from 'analytics/snowplow/events'
import { createPaymentLink, postPaymentEventLog, type PaymentEventLogRequest, type CreatePaymentLinkPayload } from 'api/payment'
import { getSubscriptionJoinItems, getHasLuxPlusOrSubscriptionInCart } from 'checkout/selectors/view/luxPlusSubscriptionItems'
import type { Stripe, CreatePaymentMethodFromElements } from '@stripe/stripe-js'
import { createOrderAccessInvites, getFullOrder } from 'api/order'
import { OrderAccessRole } from 'components/Common/OrderView/OrderItemSummaries/shareOrder/types'
import { generateBedbankChangeDatesAccommodationCheckoutItems, getBedbankChangeDatesBundleLinkage } from 'lib/checkout/accommodation/cart'
import buildToggledPropertyRateItem, { buildLoyaltyUpgradeForfeitedItem } from 'checkout/lib/utils/loyalty/buildToggledPropertyRateItem'
import buildRepricedSourceItem from 'checkout/lib/utils/loyalty/buildRepricedSourceItem'
import { getForfeitedUpgradeTotals, getPropertyRatePricingEnquiryTotals, getPropertyRatePricingItemTotals, getPropertyRatePricingSellingPrice, getPropertyRateUpgradeDiscount, getQuotedUpgradeTotal, hasPropertyRateLoyaltyUpgrade, hasPropertyRateUpgradeFeeMismatch, isPropertyRateLoyaltyPackageUpgradeItem } from 'checkout/lib/utils/loyalty/propertyRateLoyaltyUpgrade'
import { hasUnavailableCode, resolveUpgradeFailure } from 'checkout/lib/utils/loyalty/resolveUpgradeFailure'
import type { EnquiryFailure, UpgradeFailureCause } from 'checkout/lib/utils/loyalty/resolveUpgradeFailure'
import { clearRejectedPropertyRateUpgrade, recordRejectedPropertyRateUpgrade } from 'checkout/lib/utils/loyalty/rejectedPropertyRateUpgrades'
import findRefreshedPropertyRateUpgrade from 'checkout/lib/utils/loyalty/findRefreshedPropertyRateUpgrade'
import isLoyaltyUpgradeRecheckModalCurrent from 'checkout/lib/utils/loyalty/isLoyaltyUpgradeRecheckModalCurrent'
import type { RefreshedPropertyRateUpgrade } from 'checkout/lib/utils/loyalty/findRefreshedPropertyRateUpgrade'
import getPropertyRatesReduxKeys from 'lib/offer/getPropertyRatesReduxKeys'
import { fetchPropertyRates } from 'actions/PropertyActions'
import { ISO_DATE_FORMAT } from '../constants/dateFormats'
import { getSubscriptionOffer } from 'api/luxPlus'
import { generatePassengersFromOccupants } from 'checkout/lib/utils/flights/passenger'
import { CHECKOUT_ITEM_TYPE_BEDBANK, CHECKOUT_ITEM_TYPE_LE_HOTEL, PRIMARY_TRAVELLER_FORM_ID } from 'constants/checkout'
import { FlightViewTypes } from 'constants/flight'
import { Experiments } from 'constants/experiments'
import CartInitError from 'errors/CartInitError'
import { generateFlightCheckoutItem } from 'lib/checkout/flights/cart'
import { removeUnavailableCharterConnections } from 'lib/checkout/flights/removeUnavailableCharterConnections'
import { generateLuxPlusSubscriptionItems } from 'lib/checkout/luxPlusSubscription/cart'
import getPackageFromOffer from 'lib/offer/getPackageFromOffer'
import { countOccupantsForFlights } from 'lib/offer/occupancyUtils'
import { getBedbankSessionEnquiryTotals, getItemViewEnquiryTotals, type BedbankEnquiryTotals } from 'checkout/lib/utils/bedbank/enquiryTotals'
import uuidV4 from 'lib/string/uuidV4Utils'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { getAgentHubCommissionPromoCode } from 'agentHub/api/agentHubCalculateCartCommission'
import { stateToCommissionOrder } from 'agentHub/api/mappers/commissionMap'
import { updateLESubscriptionsV2 } from './LESubscriptionsActions'
import { trackClientEvent } from 'analytics/analytics'
import { reportClientError } from 'services/errorReportingService'
import type { Region } from 'constants/geo'
import type { ThunkAction } from 'redux-thunk'
import type { AppAction, DefinedAppAction } from './types/ActionTypes'
import { getEnquirySubscriber } from 'luxPlus/selectors/checkout/order'
import getDepositRemaining from 'checkout/selectors/payment/deposit/getDepositRemaining'
import { isSpoofed } from 'selectors/isSpoofed'
import { getChannelMarkupSource } from 'selectors/channelMarkupSelector'
import { getBedbankOfferChannelMarkupLeadSell } from 'lib/channelMarkup/channelMarkupLeadPricing'
import getCheckoutTravellerSchema from 'checkout/selectors/getCheckoutTravellerSchema'
import { getSourceForProperty, ghaPricedRequest, isPropertyCollectEnabled } from 'selectors/offerSelectors'
import { isMetasearchPublicRateActive } from 'lib/metasearch/metasearchPublicRate'
import { clearPendingGhaVoucher } from 'lib/metasearch/pendingGhaVoucher'
import { getGapToGooglePct } from 'lib/metasearch/ghaPriceGap'
import { getGhaPriceMatch } from 'selectors/ghaPriceMatchSelectors'
import { reportLog } from 'services/userMonitoring'
import { serialiseOccupancy } from 'lib/search/occupancy'
import { stateToDiscountOrder } from 'lib/promo/promoMappers'
import {
  createCustomerTravellerDetails,
  updateCustomerTravellerDetails,
  updateTravellerDetails,
  updateUserDetails,
} from './AuthActions'
import {
  addToUserCart,
  removeFromUserCart,
} from './UserCartActions'
import { isUserCartSupportedItem } from 'lib/checkout/userCart'
import { getBedbankSessionGroupingKey } from 'lib/checkout/bedbankSessionGroupingKey'
import {
  findPostPurchaseCheckout,
  getEffectivelyIncompleteBundleItemIds,
  getShortestFlightExpiry,
  isBedbankAccommodationOfferView,
  isBedbankItem,
  isExperienceItem,
  isFlightItem,
  isInsuranceItem,
  isMerchandiseItem,
  isTransferItem,
} from 'lib/checkout/checkoutUtils'
import { resetFlightsTimer } from 'components/Flights/FlightsSessionTimer/FlightsSessionTimer'
import { getUserCartAbandonableItems } from 'selectors/userCart'
import { isPostPurchaseAncillaryPayment } from 'checkout/selectors/payment/isPostPurchaseAncillaryPayment'
import type { ThunkDispatch } from '@reduxjs/toolkit'
import { SHOULD_AUTOBATCH } from '@reduxjs/toolkit'
import getExperienceItems from 'checkout/selectors/view/items/getExperienceItems'
import getExperienceItemsView from 'checkout/selectors/view/itemViews/getExperienceItemsView'
import { excludeNullOrUndefined } from 'checkout/utils'
import { updateBedbankPricingData } from 'actions/BedbankOfferActions'
import { trackCheckoutObservabilityEvent } from 'analytics/snowplow/checkoutAnalytics'
import { findBedbankRateMatchingItem } from 'lib/hotels/bedbankUtils'
import { SubscriptionSource } from 'api/LESubscriptions'
import { removeUnknownTravellersAndFields } from 'lib/checkout/form'
import { getPrimaryTravellerForm } from 'selectors/checkoutSelectors'
import { releaseExperienceReservationsFromItems } from 'lib/experiences/releaseExperienceReservationOnItemRemove'
import { objectKeys, omitKeys } from 'lib/object/objectUtils'
import { saveCabinOptions } from 'actions/cruise/saveCabinOptions'
import { createQuoteFromCart } from 'api/cart/createQuoteFromCart'
import type { QuoteDedupeKeys } from 'api/cart/updateCartQuote'
import { updateQuoteFromCart } from 'api/cart/updateCartQuote'
import type { ValidateOfferDiscountParams } from 'marketing/api'
import { validateOfferDiscount as validateOfferDiscountApi } from 'marketing/api'
import {
  getExperimentEnabledDecision,
  getOptimizelyExperimentVariation,
} from 'lib/optimizely/optimizelyUtils'
import { clearCheckoutObservabilityState, clearSavedCheckoutReduxCartState } from 'storage/checkout'
import { getTransferOfferLookup } from 'loyalty/lib/transferOfferUtils'
import { shouldDiscardFlightSeatsOnCheckoutExit } from 'checkout/lib/discardFlightSeatsOnExit'
import { shouldDiscardFlightBaggageOnCheckoutExit } from 'checkout/lib/discardFlightBaggageOnExit'

const EMAIL_REGEX = new RegExp(EMAIL_PATTERN)

export interface CartInitialisationParams {
  regionCode: string
  currencyCode: string
  isGift: boolean
  isRestoreCheckout: boolean
  mode?: App.CheckoutCartMode
  order?: App.Order
  connectedRoomOfferIds?: Array<string>
  isMultiCart: boolean
  restoreCartDetails?: App.CheckoutRestoredCartState
  checkoutSource?: App.CheckoutSource
  checkoutSourceRequired?: App.CheckoutSource['type']
  cartTransactionKey?: string
  // LESA support-assistant chat id, carried from a change-dates/extend-dates deep link so
  // the eventual svc-order change can be attributed back to the chat (ai_agent_context).
  conversationId?: string
  postPurchasePaymentSchedule?: App.PostPurchasePaymentSchedule
}

export function initialiseCheckout(cartItems: Array<App.Checkout.AnyItem>, params: Partial<CartInitialisationParams> = {}, initFromUserCart?: boolean): AppAction {
  return function(dispatch, getState) {
    const state = getState()
    const transformedParams: CartInitialisationParams = {
      regionCode: params.regionCode ?? state.geo.currentRegionCode,
      currencyCode: params.currencyCode ?? state.geo.currentCurrency,
      isGift: params.isGift ?? false,
      mode: params.mode,
      order: params.order,
      connectedRoomOfferIds: params.connectedRoomOfferIds,
      isMultiCart: !!initFromUserCart,
      restoreCartDetails: params.restoreCartDetails,
      checkoutSource: params.checkoutSource,
      checkoutSourceRequired: params.checkoutSourceRequired ?? params.checkoutSource?.type,
      cartTransactionKey: params.cartTransactionKey,
      isRestoreCheckout: params.isRestoreCheckout ?? false,
      conversationId: params.conversationId,
      postPurchasePaymentSchedule: params.postPurchasePaymentSchedule,
    }

    const items = removeUnavailableCharterConnections(cartItems, params.mode)
    const selectVertical = params.mode === 'vertical-select'
    if (!initFromUserCart && !selectVertical && !findPostPurchaseCheckout(params.mode)) {
      // Flight items have an empty state in bundle flow so filter them initially
      const abandonableItems = getUserCartAbandonableItems(state, items).filter(item => {
        if (params.mode !== 'vertical-select') return item
        return !isFlightItem(item)
      })
      dispatch(addToUserCart(abandonableItems, true, false, true))
    }

    const flightItemExpiry = getShortestFlightExpiry(items.filter(isFlightItem))
    if (flightItemExpiry) {
      // TODO: Stop using a cookie for this
      resetFlightsTimer(flightItemExpiry)
    }

    clearSavedCheckoutReduxCartState()
    // A guest GHA voucher belongs to the checkout it was saved for. A Buy that qualifies saves a new
    // one after this.
    clearPendingGhaVoucher()

    dispatch({
      type: CHECKOUT_INITIALISE,
      items,
      params: transformedParams,
    })
  }
}

export function clearRestoreCartPrice(): AppAction {
  return {
    type: CHECKOUT_CLEAR_CART_RESTORE_PRICE,
  }
}

export function clearCheckoutCart(): AppAction {
  return {
    type: CHECKOUT_CLEAR_CART,
  }
}

export function setCharterUpgradeDetails(details: {
  legs: Array<App.CharterUpgradeLeg>
  flightItemId: string
  searchId?: string
}): AppAction {
  return {
    type: CHECKOUT_SET_CHARTER_UPGRADE,
    details,
  }
}

export function setFlightSeatsDetails(details: NonNullable<App.CheckoutState['flightSeats']>): AppAction {
  return {
    type: CHECKOUT_SET_FLIGHT_SEATS,
    details,
  }
}

export function discardFlightSeatsCheckout(): AppAction {
  return (dispatch, getState) => {
    if (!shouldDiscardFlightSeatsOnCheckoutExit(getState().checkout)) return
    clearSavedCheckoutReduxCartState()
    dispatch({
      type: CHECKOUT_DISCARD_FLIGHT_SEATS,
    })
  }
}

export function setFlightBaggageDetails(details: NonNullable<App.CheckoutState['flightBaggage']>): AppAction {
  return {
    type: CHECKOUT_SET_FLIGHT_BAGGAGE,
    details,
  }
}

export function discardFlightBaggageCheckout(): AppAction {
  return (dispatch, getState) => {
    if (!shouldDiscardFlightBaggageOnCheckoutExit(getState().checkout)) return
    clearSavedCheckoutReduxCartState()
    dispatch({
      type: CHECKOUT_DISCARD_FLIGHT_BAGGAGE,
    })
  }
}

export function restoreCheckoutCart(cartState: Partial<App.CheckoutCartState>): AppAction {
  return {
    type: CHECKOUT_RESTORE_CART,
    cartState: cartState.items ? {
      ...cartState,
      items: removeUnavailableCharterConnections(cartState.items, cartState.mode),
    } : cartState,
  }
}

/** This action MUST be dispatched after the form schema is loaded to mark the forms as ready for display, even if no data is passed in. */
export function initialiseTravellerForms(formState?: Partial<App.Checkout.FormState>): AppAction {
  return {
    type: CHECKOUT_INITIALISE_FORM,
    formState,
  }
}

export function resetCheckoutForm(): AppAction {
  return {
    type: CHECKOUT_RESET_FORM,
  }
}

export function resetCheckoutCommission(): AppAction {
  return {
    type: CHECKOUT_RESET_COMMISSION,
  }
}

export function restoreCheckoutPayment(state: Partial<App.Checkout.PaymentState>): AppAction {
  return {
    type: CHECKOUT_RESTORE_PAYMENT,
    state,
  }
}

/**
 * Will update (more upsert) items.
 * Will update the item *in place* if it exists, otherwise, will put it at the end
 * @param item The item to update
 */
interface CheckoutItemActionOptions {
  checkoutOnly?: boolean
}

export function updateCheckoutItem(item: App.Checkout.AnyItem, options?: CheckoutItemActionOptions): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const selectVertical = state.checkout.cart.mode === 'vertical-select'
    dispatch({
      type: CHECKOUT_UPDATE_ITEM,
      item,
      meta: {
        [SHOULD_AUTOBATCH]: true,
      },
    })
    if (!options?.checkoutOnly && !selectVertical && isUserCartSupportedItem(item) && !findPostPurchaseCheckout(state.checkout.cart.mode)) {
      dispatch(addToUserCart([item], true, false, true))
    }
  }
}

/**
 * Replaces the insurance selection in one reducer transition. This is used by
 * the spoof comparison flow once a provider quote has been selected; preview
 * inputs remain local to that flow and never create cart items.
 */
export function replaceInsuranceSelection(items: Array<App.Checkout.InsuranceItem>): AppAction {
  return (dispatch, getState) => {
    const cart = getState().checkout.cart
    const firstInsuranceIndex = cart.items.findIndex(isInsuranceItem)
    const nonInsuranceItems = cart.items.filter(item => !isInsuranceItem(item))
    let nextItems: Array<App.Checkout.AnyItem>

    if (firstInsuranceIndex === -1) {
      nextItems = [...nonInsuranceItems, ...items]
    } else {
      nextItems = [
        ...cart.items.slice(0, firstInsuranceIndex).filter(item => !isInsuranceItem(item)),
        ...items,
        ...cart.items.slice(firstInsuranceIndex).filter(item => !isInsuranceItem(item)),
      ]
    }

    if (equal(cart.items, nextItems)) return

    dispatch({
      type: CHECKOUT_REPLACE_INSURANCE_SELECTION,
      items: nextItems,
      restoredCartDetails: {
        ...cart.restoredCartDetails,
        originalMemberTotal: undefined,
        originalTotal: undefined,
      },
    })
  }
}

export function removeItem(itemId: string, options?: CheckoutItemActionOptions): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const item = state.checkout.cart.items.find(item => item.itemId === itemId)
    const willSyncRemovalToUserCart = !options?.checkoutOnly && state.checkout.cart.mode !== 'vertical-select' && item && (
      isMerchandiseItem(item) || isTransferItem(item) || isExperienceItem(item)
    )

    const incompleteBundleItemIds = getEffectivelyIncompleteBundleItemIds(itemId, state.checkout.cart.items)

    if (!willSyncRemovalToUserCart) {
      releaseExperienceReservationsFromItems(state.checkout.cart.items.filter(item => {
        // Tolerate malformed items.
        if (!item.itemId) return false
        // Match the current item plus any candidates to prune. We'll leave filtering on experience
        // items to `releaseExperienceReservationsFromItems`.
        return incompleteBundleItemIds.has(item.itemId) || item.itemId === itemId
      }))
    }

    dispatch({
      type: CHECKOUT_REMOVE_ITEM,
      itemId,
      meta: {
        [SHOULD_AUTOBATCH]: true,
      },
    })
    incompleteBundleItemIds.forEach(itemId => {
      dispatch({
        type: CHECKOUT_REMOVE_ITEM,
        itemId,
        meta: {
          [SHOULD_AUTOBATCH]: true,
        },
      })
    })

    if (willSyncRemovalToUserCart) {
      dispatch(removeFromUserCart([itemId]))
    }

    if (item?.itemType === 'bedbankHotel') {
      dispatch(updateBedbankSession())
    }
  }
}

export function removeItems(itemIds: Array<string>): AppAction {
  return (dispatch) => {
    itemIds.forEach((item) => {
      dispatch(removeItem(item))
    })
  }
}

export function addItem(item: App.Checkout.AnyItem, options?: CheckoutItemActionOptions): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    if (!options?.checkoutOnly && state.checkout.cart.mode !== 'vertical-select' &&
      isUserCartSupportedItem(item)
    ) {
      // Flight items have an empty state in bundle flow
      dispatch(addToUserCart([item], true, false, true))
    }
    dispatch({
      type: CHECKOUT_ADD_ITEM,
      item,
      meta: {
        [SHOULD_AUTOBATCH]: true,
      },
    })
  }
}

export function addItems(items: Array<App.Checkout.AnyItem>): AppAction {
  return (dispatch) => {
    items.forEach((item) => {
      dispatch(addItem(item))
    })
  }
}

export function setCheckoutExperiencesPassportReconciliation(key: string, status: 'loading' | 'ready' | 'failed'): AppAction {
  return { type: CHECKOUT_SET_EXPERIENCES_PASSPORT_RECONCILIATION, key, status }
}

export function addToCheckoutCart(items: Array<App.Checkout.AnyItem> | App.Checkout.AnyItem, initParams?: Partial<CartInitialisationParams>): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const arrayItems = Array.isArray(items) ? items : [items]

    if ((!state.checkout.cart.isMultiItemMode || state.checkout.cart.cartId === null) || !!initParams) {
      dispatch(initialiseCheckout(arrayItems, initParams))
    } else {
      arrayItems.forEach(item => dispatch(addItem(item)))
    }
  }
}

export function toggleMultiCartItemMode(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const isMultiItemMode = state.checkout.cart.isMultiItemMode
    dispatch(clearCheckoutCart())
    dispatch({
      type: CHECKOUT_SET_MULTI_CART_ITEM_MODE,
      isMultiItemMode: !isMultiItemMode,
    })
  }
}

export function setSpecialRequest(itemId: string, request: string): AppAction {
  return {
    type: CHECKOUT_SET_SPECIAL_REQUEST,
    itemId,
    request,
  }
}

export function addRoomsToBeConnected(offerId: string): AppAction {
  return (dispatch) => {
    dispatch({
      type: CHECKOUT_ADD_ROOMS_TO_BE_CONNECTED,
      offerId,
    })
  }
}

export function removeRoomsToBeConnected(offerId: string): AppAction {
  return (dispatch) => {
    dispatch({
      type: CHECKOUT_REMOVE_ROOMS_TO_BE_CONNECTED,
      offerId,
    })
  }
}

export function checkoutSetRoomsConnected(offerId: string, shouldBeConnected: boolean): AppAction {
  if (shouldBeConnected) {
    return addRoomsToBeConnected(offerId)
  } else {
    return removeRoomsToBeConnected(offerId)
  }
}

/**
 * Marks the current checkout as a metasearch guest checkout, allowing the
 * checkout routes to mount without an authenticated user. Dispatch after cart
 * initialisation (CHECKOUT_INITIALISE resets checkout state) and before
 * navigateToCheckout, mirroring the auto-applied voucher ordering.
 */
export function setCheckoutGuestMode(enabled: boolean): AppAction {
  return (dispatch, getState) => {
    dispatch({
      type: CHECKOUT_SET_GUEST_CHECKOUT_MODE,
      enabled,
    })
    setGuestCheckoutSessionCartId(enabled ? getState().checkout.cart.cartId : null)
  }
}

/** Records a guest's explicit choice to retry checkout without their GHA voucher. */
export function setGuestCheckoutVoucherDisabled(disabled: boolean): AppAction {
  return {
    type: CHECKOUT_SET_GUEST_CHECKOUT_VOUCHER_DISABLED,
    disabled,
  }
}

export function processingStart(): AppAction {
  return {
    type: CHECKOUT_PROCESS_START,
  }
}

export function processingSuccess(): AppAction {
  return function(dispatch) {
    dispatch({
      type: CHECKOUT_PROCESS_SUCCESS,
    })
    setGuestCheckoutSessionCartId(null)
    clearSavedCheckoutReduxCartState()
    clearCheckoutObservabilityState()
  }
}

export function processingCancel(): AppAction {
  return {
    type: CHECKOUT_PROCESS_CANCEL,
  }
}

export function processingFailure(name: string, status?: number, errorMsg?: string): AppAction {
  return {
    type: CHECKOUT_PROCESS_FAILURE,
    data: {
      name,
      status,
      errorMsg,
    },
  }
}

function resetPaymentSelectionBeforeCreditApplied(dispatch: AppDispatch, state: App.State) {
  const creditPayableAmount = getCreditPayableAmount(state)
  const depositBalance = getDepositRemaining(state)

  // before credit is applied check if selected payment option is deposit and whether credit amount is greater than deposit balance
  if (!state.checkout.payment.useCredit && state.checkout.payment.paymentSelected === PAYMENT_OPTIONS.DEPOSIT &&
    creditPayableAmount >= depositBalance) {
    dispatch(updatePaymentSelection(PAYMENT_OPTIONS.FULL))
  }
}

export function toggleCredit(): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    resetPaymentSelectionBeforeCreditApplied(dispatch, state)

    dispatch({
      type: CHECKOUT_TOGGLE_CREDIT,
    })
  }
}

export function setUsingCredit(useCredit: boolean): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (state.checkout.payment.useCredit === useCredit) {
      // it's already set
      return
    }

    resetPaymentSelectionBeforeCreditApplied(dispatch, state)

    dispatch({
      type: CHECKOUT_TOGGLE_CREDIT,
      useCredit,
    })
  }
}

export function toggleGiftCard(): AppAction {
  return (dispatch) => {
    dispatch({
      type: CHECKOUT_TOGGLE_GIFT_CARD,
    })
  }
}

export function setClassicRewards(
  classicRewards: App.StatefulData<App.Checkout.ClassicRewardCheckoutPricing, 'unavailable'>,
): AppAction {
  return (dispatch) => {
    dispatch({
      type: CHECKOUT_SET_CLASSIC_REWARDS,
      classicRewards,
    })
  }
}

export function setUsingGiftCard(useGiftCard: boolean): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (state.checkout.payment.useGiftCard === useGiftCard) {
      // it's already set
      return
    }

    dispatch({
      type: CHECKOUT_TOGGLE_GIFT_CARD,
      useGiftCard,
    })
  }
}

export function applyVelocityBurn(points: number): AppAction {
  return {
    type: CHECKOUT_APPLY_VELOCITY_BURN,
    points,
  }
}

export function setPartnershipStatus(
  partnership: 'velocity',
  status: boolean,
): AppAction {
  return {
    type: CHECKOUT_APPLY_PARTNERSHIP_STATUS,
    partnership,
    status,
  }
}

export function setVelocityBurnModalStatus(isActive: boolean, isClean = false): AppAction {
  const data = { isActive, isClean }
  return {
    type: CHECKOUT_SET_VELOCITY_BURN_MODAL_STATUS,
    data,
  }
}

export function getVelocityMemberDetails(
  token: string,
  onComplete?: (result: ApiActionResult<VelocityMemberProfile>) => void,
) {
  return {
    type: API_CALL,
    api: FETCH_VELOCITY_MEMBER_DETAILS,
    onComplete,
    request: async() => {
      const memberProfile = await getVelocityMemberProfile(token)
      if (memberProfile.pointBalance < VIRGIN_VELOCITY_BURN_MINIMUM) {
        const intl = getCurrentIntl()
        showSnackbar(
          intl.formatMessage({
            id: 'fi9-cn1PRxN7kHR_skot',
            defaultMessage: 'Sorry! Your Velocity point balance is insufficient for payment',
            description: 'Snackbar error when Velocity points balance is too low for payment',
          }),
          'critical',
        )
      }
      return memberProfile
    },
  }
}

export function clearVelocityMemberDetails(): AppAction {
  return {
    type: CHECKOUT_CLEAR_VELOCITY_MEMBER_DETAILS,
  }
}

export function saveVelocitySSO(data: Partial<App.Checkout.VelocitySSO>): AppAction {
  return {
    type: CHECKOUT_SET_VELOCITY_SSO,
    data,
  }
}

export function fetchTravellerFormSchema(): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const key = getTravellerFormSchemaRequestKey(state)
    if (
      state.checkout.schemaData[key] ||
      state.checkout.fetchingSchemaData[key] ||
      state.checkout.schemaDataErrors[key]
    ) {
      // already processing it
      return
    }

    const requestPayload = getTravellerFormSchemaRequest(state)

    if (requestPayload.items.length > 0) {
      dispatch({
        type: API_CALL,
        api: FETCH_TRAVELLER_FORM_SCHEMA,
        schemaRequestData: requestPayload,
        request: () => retrieveTravellerDetailsForm(requestPayload),
        key,
        isDevMode: state.checkout.cart.isDevToolsEnabled,
      })
    } else {
      dispatch({
        type: API_CALL,
        api: FETCH_TRAVELLER_FORM_SCHEMA,
        schemaRequestData: requestPayload,
        request: () => Promise.resolve(null),
        key,
        isDevMode: state.checkout.cart.isDevToolsEnabled,
      })
    }
  }
}

export function removeTravellerSchema(): AppAction {
  return { type: CHECKOUT_REMOVE_TRAVELLER_SCHEMA }
}

export function setTravellerForm(form: App.Checkout.FormState): AppAction {
  return {
    type: CHECKOUT_SET_FORM,
    form,
  }
}

export function setCheckoutDeliveryForm(data: App.Checkout.DeliveryForm): AppAction {
  return {
    type: CHECKOUT_SET_DELIVERY_FORM,
    form: data,
  }
}

export function clearTravellerForm(travellerId: string): AppAction {
  return {
    type: CHECKOUT_CLEAR_TRAVELLER_FORM,
    travellerId,
  }
}

function travellerDetailsToCompanionPayload(traveller: App.Checkout.TravellerForm): Omit<App.TravelCompanion, 'id'> {
  return {
    title: traveller.data.title as App.Title,
    firstName: traveller.data.firstName,
    middleName: traveller.data.middleName,
    lastName: traveller.data.lastName,
    dateOfBirth: traveller.data.dateOfBirth,
    countryOfResidence: traveller.data.countryOfResidence,
    phone: traveller.data.phonePrefix && traveller.data.phone ? `${traveller.data.phonePrefix}${traveller.data.phone}` : undefined,
    email: traveller.data.email,
  }
}

export function saveTravellerForm(
  travellerData: App.Checkout.TravellerForm,
  options: {
    /**
     * If true, saving a new traveller with `saveDetails: true` will cause the companion to be created immediately,
     * rather than when the purchase is completed.
     */
    createCompanionImmediately: boolean
  } = { createCompanionImmediately: false },
): AppAction {
  return function(dispatch, getState) {
    const state = getState()

    const schema = getCheckoutTravellerSchema(state)?.accommodationFlightSchema
    if (!schema) { return }

    const { form } = state.checkout

    // The data is being deliberately saved, so it's no longer tentative prefill data
    const traveller = omitKeys(['isTentativePrefilled'], travellerData)

    const newTravellerFormList = sortTravellers([...form.travellerForms.filter(x => x.id !== traveller.id), traveller])

    const newFormState = { ...form, travellerForms: newTravellerFormList }

    if (!equal(form, newFormState)) {
      dispatch(setTravellerForm(newFormState))

      // For cruise, invalidate the pricing data for the item if any details have changed
      const relatedItem = schema.properties[traveller.id].relatedItem
      if (relatedItem?.type === 'cruise' && relatedItem.id) {
        dispatch(saveCabinOptions(relatedItem.id))
      }
    }

    if (traveller.type === 'new' && traveller.saveDetails && options.createCompanionImmediately) {
      const companionData = travellerDetailsToCompanionPayload(traveller)
      dispatch(createCustomerTravellerDetails(companionData, {
        onCreated: companion => {
          const formState = getState().checkout.form
          dispatch(setTravellerForm({
            ...formState,
            travellerForms: formState.travellerForms.map(t => {
              if (t.id === traveller.id) {
                return {
                  ...t,
                  type: 'companion',
                  travellerOptionKey: `companion-${companion.id}`,
                  data: t.data,
                  companionId: companion.id,
                  saveDetails: false,
                }
              } else {
                return t
              }
            }),
          }))
        },
      }))
    }
  }
}

export function saveTravellerDataFromForms(): AppAction {
  return function(dispatch, getState) {
    const state = getState()
    const travellerForms = state.checkout.form.travellerForms
    const primaryTravellerForm = getPrimaryTravellerForm(state)
    const account = state.auth.account
    let didUpdateAccountHolder = false

    travellerForms.forEach((traveller) => {
      if (!traveller.saveDetails) {
        return
      }

      if (traveller.type === 'new') {
        dispatch(createCustomerTravellerDetails(travellerDetailsToCompanionPayload(traveller)))
      } else if (traveller.type === 'companion' && traveller.companionId) {
        dispatch(updateCustomerTravellerDetails({
          id: traveller.companionId,
          ...travellerDetailsToCompanionPayload(traveller),
        }))
      } else if (traveller.type === 'account-holder') {
        dispatch(updateUserTravellerDetails(traveller))
        didUpdateAccountHolder = true
      }
    })

    if (
      !didUpdateAccountHolder &&
      (primaryTravellerForm?.data.phone && primaryTravellerForm?.data.phonePrefix) &&
      !account.phone
    ) {
      // update accounts phone number from the primary traveller if the account doesn't have one
      dispatch(updateUserDetails({
        phone: primaryTravellerForm.data.phone,
        phonePrefix: primaryTravellerForm.data.phonePrefix,
      }))
    }

    if (state.checkout.orderId) {
      const shareBookingVariation = getOptimizelyExperimentVariation(
        state,
        Experiments.opexCheckoutTravellerCardShareBooking.id,
      )
      const isTravellerCardShareBookingEnabled =
        getExperimentEnabledDecision(shareBookingVariation) && config.BRAND === LUXURY_ESCAPES
      createTravellerOrderAccessInvites(state.checkout.orderId, state, isTravellerCardShareBookingEnabled)
    }
  }
}

async function createTravellerOrderAccessInvites(
  orderId: string,
  state: App.State,
  isTravellerCardShareBookingEnabled: boolean,
) {
  if (!isTravellerCardShareBookingEnabled) return

  const purchaserEmail = state.auth.account.email?.trim().toLowerCase()
  const seen = new Set<string>()
  const invitations: Array<{ email: string; role: App.OrderAccessRole }> = []

  for (const traveller of state.checkout.form.travellerForms) {
    if (traveller.optionalGuestShareBooking !== true) continue
    if (traveller.id === PRIMARY_TRAVELLER_FORM_ID) continue
    const email = traveller.data.email?.trim()
    if (!email || !EMAIL_REGEX.test(email)) continue
    const emailLower = email.toLowerCase()
    if (emailLower === purchaserEmail || seen.has(emailLower)) continue
    seen.add(emailLower)
    invitations.push({ email, role: OrderAccessRole.MANAGER })
  }

  if (invitations.length === 0) return

  try {
    await createOrderAccessInvites(orderId, {
      invitations,
      brand: config.BRAND,
    })
  } catch(err) {
    reportClientError(err instanceof Error ? err : new Error('traveller_share_booking_invites_failed'), {
      orderId,
      inviteCount: invitations.length,
    })
  }
}

export function cleanTravellerFormData(formSchema: App.Checkout.FormSchema): AppAction {
  return function(dispatch, getState) {
    const state = getState()

    const travellerForms = state.checkout.form.travellerForms

    if (travellerForms.length > 0) {
      // Have existing data - make sure there's no remaining data from previous schema that doesn't fit this one
      const cleanedForms = removeUnknownTravellersAndFields(formSchema, travellerForms)
      if (!equal(travellerForms, cleanedForms)) {
        dispatch(setTravellerForm({
          ...state.checkout.form,
          travellerForms: cleanedForms,
        }))
      }
    }
  }
}

export function initialiseTravellerFormDataForAccountHolder(formSchema: App.Checkout.FormSchema): AppAction {
  return function(dispatch, getState) {
    const state = getState()

    const account = state.auth.account

    const isLuxPlusMemberRedeemingBenefit = getIsLuxPlusMemberRedeemingBenefitSchemaRequest(state)

    const form: App.Checkout.TravellerForm = {
      id: PRIMARY_TRAVELLER_FORM_ID,
      type: 'account-holder',
      travellerOptionKey: 'account-holder',
      isTentativePrefilled: !isLuxPlusMemberRedeemingBenefit,
      data: {
        title: account.title,
        firstName: account.givenName,
        lastName: account.surname,
        dateOfBirth: account.dob,
        phone: account.phone,
        phonePrefix: account.phonePrefix,
        email: account.email,
        postcode: account.postcode,
        countryOfResidence: account.countryCode,
      },
    }

    const cleanedForms = removeUnknownTravellersAndFields(formSchema, [form])
    dispatch(initialiseTravellerForms({
      travellerForms: cleanedForms,
    }))
  }
}

export function respondShadowBanUserError(paymentType: string): AppAction {
  return function(dispatch, getState) {
    const state = getState()

    if (!state.checkout.processing) {
      dispatch(processingStart())
    }

    const intl = getCurrentIntl()
    let responseMsg: string
    switch (paymentType) {
      case CREDIT_PAYMENT_TYPE:
      case PROMO_PAYMENT_TYPE:
        responseMsg = intl.formatMessage({
          id: 'urfHbRrBt4fP_I4dj6Nb',
          defaultMessage: 'An error occurred while processing your card',
          description: 'Error message when credit card processing fails at checkout',
        })
        break
      case STRIPE_PAYMENT_TYPE:
        responseMsg = intl.formatMessage({
          id: '8cQqybwEnkrx-ckjSI0V',
          defaultMessage: 'Your card was declined. Decline Code: [1]',
          description: 'Error message when a Stripe card is declined at checkout',
        })
        break
      default:
        responseMsg = intl.formatMessage({
          id: 'rbP-S1wOmcEENYjjGL8C',
          defaultMessage: 'Default Error Message',
          description: 'Fallback error message for unknown payment errors at checkout',
        })
    }

    setTimeout(() => {
      dispatch(processingFailure(responseMsg, 400))
      dispatch(genericOrderErrorModalOpen([responseMsg]))
    }, 3000)
  }
}

export function updateUserTravellerDetails(details: App.Checkout.TravellerForm): AppAction {
  return function(dispatch, getState) {
    const state = getState()
    const account = state.auth.account
    const customerId = account.memberId

    if (!customerId) { return }

    const accountUpdate: Partial<App.AuthAccount> = {}

    if (details.data.firstName && !account.givenName) {
      accountUpdate.givenName = details.data.firstName
    }
    if (details.data.middleName && !account.middleName) {
      accountUpdate.middleName = details.data.middleName
    }
    if (details.data.lastName && !account.surname) {
      accountUpdate.surname = details.data.lastName
    }
    if (
      details.data.phone && details.data.phonePrefix &&
      // Only update phone number if they don't already have one, because we have a
      // confirmation process for changing the phone number on the account.
      !account.phone
    ) {
      accountUpdate.phone = details.data.phone
      accountUpdate.phonePrefix = details.data.phonePrefix
    }

    if (details.data.dateOfBirth) {
      accountUpdate.dob = details.data.dateOfBirth
    }
    if (details.data.postcode) {
      accountUpdate.postcode = details.data.postcode
    }

    if (objectKeys(accountUpdate).length > 0) {
      dispatch(updateUserDetails(accountUpdate))
    }

    dispatch(updateTravellerDetails({
      customerId,
      title: details.data.title as App.Title,
      gender: deduceGenderFromTitle(details.data.title as App.Title) !== 'Other'
        ? deduceGenderFromTitle(details.data.title as App.Title)
        : (details.data.gender as App.Gender) ?? 'Other',
      middleName: details.data.middleName,
      addressDetails: {
        address: details.data.address,
        city: details.data.city,
        state: details.data.state,
        usStateOfResidence: details.data.usStateOfResidence,
        countryOfResidence: details.data.countryOfResidence,
        postcode: details.data.postcode,
      },
    }))
  }
}

export function updatePaymentSelection(paymentSelected: PAYMENT_OPTIONS): AppAction {
  return {
    type: CHECKOUT_UPDATE_PAYMENT_SELECTION,
    paymentSelected,
  }
}

export function saveGroupPayment(
  allocation: App.Checkout.GroupPaymentAllocation,
  preview: App.Checkout.GroupPaymentPreviewResult,
  fingerprint: string,
): AppAction {
  return {
    type: CHECKOUT_SAVE_GROUP_PAYMENT,
    allocation,
    preview,
    fingerprint,
  }
}

export function clearGroupPayment(): AppAction {
  return {
    type: CHECKOUT_CLEAR_GROUP_PAYMENT,
  }
}

export function selectStaticScheduleOption(optionId: string | null): AppAction {
  return {
    type: CHECKOUT_SELECT_STATIC_SCHEDULE_OPTION,
    selectedStaticScheduleOptionId: optionId,
  }
}

export function setPaymentScheduleBalanceType(paymentScheduleBalanceType: 'next_charge' | 'full_balance'): AppAction {
  return {
    type: CHECKOUT_SET_PAYMENT_SCHEDULE_BALANCE_TYPE,
    paymentScheduleBalanceType,
  }
}

export function setPaymentScheduleFullBalanceOnly(paymentScheduleFullBalanceOnly: boolean): AppAction {
  return {
    type: CHECKOUT_SET_PAYMENT_SCHEDULE_FULL_BALANCE_ONLY,
    paymentScheduleFullBalanceOnly,
  }
}

export function setDynamicPaymentScheduleFrequency(dynamicPaymentScheduleFrequency: 'weekly' | 'fortnightly' | 'monthly'): AppAction {
  return {
    type: CHECKOUT_SET_DYNAMIC_PAYMENT_SCHEDULE_FREQUENCY,
    dynamicPaymentScheduleFrequency,
  }
}

export function setSaveCheckoutCardAsLuxPlusBackup(saveCheckoutCardAsLuxPlusBackup: boolean): AppAction {
  return {
    type: CHECKOUT_SET_SAVE_CARD_AS_LUX_PLUS_BACKUP,
    saveCheckoutCardAsLuxPlusBackup,
  }
}

export function setPayLuxPlusRenewalWithPoints(payLuxPlusRenewalWithPoints: boolean | undefined): AppAction {
  return {
    type: CHECKOUT_SET_PAY_LUX_PLUS_RENEWAL_WITH_POINTS,
    payLuxPlusRenewalWithPoints,
  }
}

export function setTerminalReaderId(readerId: string): AppAction {
  return {
    type: SET_TERMINAL_READER_ID,
    readerId,
  }
}

export function updateExperienceItem(
  experienceId: string,
  data: { details?: ExperienceDetails, tickets?: Array<App.Checkout.ExperienceItemTicket> }): AppAction {
  return {
    type: CHECKOUT_UPDATE_EXPERIENCE_ITEM,
    id: experienceId,
    data,
  }
}

export function removeUnpurchasableItems(): AppAction {
  return function(dispatch, getState) {
    const state = getState()

    // Remove unpurchasable experience tickets
    const experienceItems = getExperienceItems(state)
    const expItemViewsById = arrayToMap(getExperienceItemsView(state).data.filter(Boolean), v => v.item.itemId)
    experienceItems.forEach(item => {
      const itemView = expItemViewsById.get(item.itemId)
      if (!itemView) { return }
      const unavailableTicketIds = new Set(itemView.ticketViews.filter(v => v.unavailable).map(v => v.ticket.id))

      const availableTickets = item.tickets.filter(t => !unavailableTicketIds.has(t.ticketId))

      if (availableTickets.length === 0) {
        dispatch(removeItem(item.itemId))
      }
      else if (availableTickets.length < item.tickets.length) {
        dispatch(updateExperienceItem(item.experienceId, { tickets: availableTickets }))
      }
    })
  }
}
export function setLuxPlusUpsellData(
  params: SnowplowEvent,
): AppAction {
  return {
    type: CHECKOUT_SET_LUXPLUS_UPSELL_DATA,
    eventData: params,
  }
}

export function setLuxPlusUpsellDecision(
  luxPlusUpsellDecision: 'accepted' | 'declined',
): AppAction {
  return {
    type: CHECKOUT_SET_LUXPLUS_UPSELL_DECISION,
    luxPlusUpsellDecision,
  }
}

/**
 * @deprecated Set these values in the initial `intialiseCheckout` instead
 */
export function setPostPurchaseOrder(order: App.Order, mode: App.CheckoutPostPurchaseMode): AppAction {
  return {
    type: CHECKOUT_SET_POST_PURCHASE,
    order,
    mode,
  }
}

export function showCorporateBenefitsForm(promoCode: string, corporateName: string, allowedEmailDomains: Array<string>): AppAction {
  return {
    type: CHECKOUT_SHOW_PROMO_CORPORATE_BENEFITS,
    promoCode,
    corporateName,
    allowedEmailDomains,
  }
}

export function hideCorporateBenefitsForm(): AppAction {
  return {
    type: CHECKOUT_HIDE_PROMO_CORPORATE_BENEFITS,
  }
}

export function showFriendsAndFamilyForm(promoCode: string, category: string): AppAction {
  return {
    type: CHECKOUT_SHOW_PROMO_FRIENDS_AND_FAMILY,
    promoCode,
    category,
  }
}

export function hideFriendsAndFamilyForm(): AppAction {
  return {
    type: CHECKOUT_HIDE_PROMO_FRIENDS_AND_FAMILY,
  }
}

export function requestCorporateBenefitsPromo(corporateEmail: string): AppAction {
  return async function(dispatch, getState) {
    const state = getState()

    dispatch({
      type: API_CALL,
      api: CHECKOUT_REQUEST_CORPORATE_BENEFITS_PROMO,
      submittedEmail: corporateEmail,
      request: () => registerCorporateBenefits(
        state.checkout.corporatePromoForm.sourceCodeName as string,
        corporateEmail,
      ),
    })
  }
}

export function requestFriendsAndFamilyPromo(data: Omit<RestrictedPromoRequestData,
  'code' | 'category' | 'requester' | 'requesterEmail' | 'requesterFirstName' | 'requesterLastName' | 'requesterOfferHeadline' | 'requesterOfferId'
>): AppAction {
  return async function(dispatch, getState) {
    const state = getState()
    let requesterOffer: ReturnType<typeof getFriendsAndFamilyRequesterOffer> = {
      offerId: undefined,
      offerHeadline: undefined,
    }

    try {
      requesterOffer = getFriendsAndFamilyRequesterOffer(state)
    } catch {
      // Offer metadata is optional enrichment and must not block the promo request.
    }

    dispatch({
      type: API_CALL,
      api: CHECKOUT_REQUEST_FRIENDS_AND_FAMILY_PROMO,
      submittedEmail: data.email,
      request: () => registerFriendsAndFamily({
        ...data,
        code: state.checkout.friendsAndFamilyPromoForm.sourceCodeName!,
        category: state.checkout.friendsAndFamilyPromoForm.category!,
        requester: {
          email: state.auth.account.email?.trim() || undefined,
          firstName: state.auth.account.givenName,
          lastName: state.auth.account.surname,
          offerHeadline: requesterOffer.offerHeadline,
          offerId: requesterOffer.offerId,
        },
      }),
    })
  }
}

export function applyCommissionPromoCode(code: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const discountRequestOrder = stateToDiscountOrder(state)

    dispatch({
      type: API_CALL,
      api: FETCH_COMMMISSION_PROMO,
      request: () => getPromoV2({
        codeName: code,
        order: discountRequestOrder,
        userId: state.auth.account.memberId as string,
        requestSource: isSpoofed(state) ? 'global-checkout-spoof' : 'global-checkout',
      }),
    })
  }
}

function isPromotion(referral: App.Promotion | App.ReferralError): referral is App.Promotion {
  return 'code' in referral && 'id' in referral
}

export function addPromoCode(codeName?: string, hidePromoCode = false, voucherIds?: Array<string>): AppAction {
  return async function(dispatch, getState) {
    const intl = getCurrentIntl()
    const applyPromoFailedHeading = intl.formatMessage({
      id: 'YiRQR1AYU3kDCNaapnKg',
      defaultMessage: 'Couldn’t apply promotion',
      description: 'Snackbar title when a promo or voucher apply request fails in checkout',
    })
    try {
      const state = getState()
      if (!codeName && !voucherIds) {
        return
      }
      // If no code name or voucher ids are provided, use the current promo code and voucher ids
      // Since if we apply addPromoCode for promo code
      // We need to take into account the current voucher ids
      const currentVoucherIds = voucherIds ?? state.checkout.payment.voucherIds
      const currentPromoCode = codeName ?? state.checkout.payment.promoCode
      if (!currentPromoCode && (!currentVoucherIds || currentVoucherIds.length === 0)) {
        return
      }
      if (currentPromoCode && state.checkout.cart.items.some(item => isFlightItem(item) && item.isPromotionPriceApplied)) {
        dispatch({
          type: CHECKOUT_RESET_PROMO_CODE,
        })
        if (currentVoucherIds?.length) {
          dispatch(addPromoCode(undefined, false, currentVoucherIds))
        }
        return
      }
      const discountRequestOrder = stateToDiscountOrder(state)
      // Nothing to price yet: a discount request with no items comes back rejected as
      // belonging to another offer, which on a refresh discards a voucher the customer had.
      // SingleCheckoutPage re-fires this from its subTotal effect once prices settle.
      if (discountRequestOrder.items.length === 0) {
        return
      }
      dispatch({
        type: CHECKOUT_FETCHING_PROMO_CODE,
      })
      let referralResult: App.Promotion | App.ReferralError | undefined

      if (currentPromoCode && couldBeReferralCode(currentPromoCode)) {
        referralResult = await getReferralPromotion(state, currentPromoCode)
        if (referralResult && !isPromotion(referralResult)) {
          const errMsg = referralResult.message ?? intl.formatMessage({
            id: 'ejeTCdrvEaU4T-181V9Z',
            defaultMessage: 'Failed to apply referral code',
            description: 'Error message shown when applying a referral code fails in checkout',
          })
          showSnackbar(errMsg, 'critical', {
            heading: applyPromoFailedHeading,
          })
          dispatch({
            type: CHECKOUT_APPLY_PROMO_CODE_FAILED,
            error: errMsg,
          })
          return
        }
      }

      let codeNameLookup = currentPromoCode
      if (codeNameLookup && referralResult && isPromotion(referralResult)) {
        codeNameLookup = referralResult.code
      }
      const promotion = await getPromoV2({
        codeName: codeNameLookup,
        voucherIds: currentVoucherIds,
        order: discountRequestOrder,
        userId: state.auth.account.memberId as string,
        requestSource: isSpoofed(state) ? 'global-checkout-spoof' : 'global-checkout',
      })

      if (promotion) {
        verifyPromotion(promotion, state)
        const requestedVoucherIds = currentVoucherIds ?? []
        dispatch(setVoucherIds(requestedVoucherIds))
        applyPromotion(promotion, dispatch, hidePromoCode)
      }
    } catch(e) {
      const err = e as {
        status?: number
        result?: { message?: string; errors?: Array<{ message: string }> }
        message?: string
        metadata?: { corporateName?: string; allowedEmailDomains?: Array<string>; category?: string }
      }
      const reportApplyFailure = () => {
        const apiErrorMessage = err.result?.errors?.[0]?.message
        const fallbackMessage = e instanceof Error ?
          e.message :
            intl.formatMessage({
              id: 'HW2tNHXnyAdOAKyA9d-Y',
              defaultMessage: 'Could not apply promotion',
              description: 'Generic error when a promo or voucher apply request fails in checkout with no specific message',
            })
        const errorMessage = apiErrorMessage ?? err.message ?? err.result?.message ?? fallbackMessage

        showSnackbar(errorMessage, 'critical', {
          heading: applyPromoFailedHeading,
        })
        dispatch({
          type: CHECKOUT_APPLY_PROMO_CODE_FAILED,
          error: errorMessage,
        })
      }

      if (codeName && err.status === 422) {
        const messageCode = err.result?.message

        if (messageCode === 'corporateEmailRequired') {
          const corporateName = err.metadata?.corporateName
          const allowedEmailDomains = err.metadata?.allowedEmailDomains

          if (corporateName && allowedEmailDomains) {
            dispatch(showCorporateBenefitsForm(codeName, corporateName, allowedEmailDomains))
            return
          }
        } else if (messageCode === 'restrictedCategory') {
          // todo: rename it to more appropriate name
          // when more categories is added
          const category = err.metadata?.category

          if (category) {
            dispatch(showFriendsAndFamilyForm(codeName, category))
            return
          }
        }
      }

      reportApplyFailure()
    }
  }
}

export function setVoucherIds(voucherIds: Array<string>): AppAction {
  return {
    type: CHECKOUT_SET_VOUCHER_IDS,
    voucherIds,
  }
}

export function setAgentRequest3ds(value: boolean): AppAction {
  return {
    type: CHECKOUT_SET_AGENT_REQUEST_3DS,
    value,
  }
}

export function clearVoucherIds(): AppAction {
  return (dispatch, getState) => {
    dispatch({
      type: CHECKOUT_CLEAR_VOUCHER_IDS,
    })

    const promoCode = getState().checkout.payment.promoCode
    if (promoCode) {
      dispatch(addPromoCode(promoCode, false, []))
    } else {
      dispatch(resetPromoCode())
    }
  }
}

async function getReferralPromotion(state: App.State, codeName: string): Promise<App.Promotion | App.ReferralError | undefined> {
  const regionCode = state.geo.currentRegionCode
  const { data } = getCheckoutTotalsView(state)
  const itemTypes = state.checkout.cart.items.map((i) => i.itemType)
  const payableTotal = data.subTotal + data.taxesAndFees

  if (couldBeReferralCode(codeName)) {
    return getReferralPromo({
      codeName,
      regionCode,
      brand: config.BRAND,
      cartValue: payableTotal,
      itemTypes,
    })
  }
  return
}

function couldBeReferralCode(codeName: string): boolean {
  return codeName.slice(0, 6).includes('INVITE')
}

/**
 * @deprecated - These checks are moving into svc-promo via the /api/promo/discount endpoint
 */
function verifyPromotion(
  promotion: App.Promotion,
  state: App.State,
) {
  verifyPromoPayMethods(promotion, state)
  verifyPromoOnAirlineCarriers(promotion, state)
  verifyPromoOnCharterFlights(promotion, state)
}

function verifyPromoPayMethods(promotion: App.Promotion, state: App.State) {
  const paymentMethodAvailability = getPaymentMethodAvailability(state)
  if (
    promotion.allowedPaymentMethods.length > 0 &&
    promotion.allowedPaymentMethods.every((paymentMethod: PaymentMethod) => !paymentMethodAvailability[paymentMethod])
  ) {
    const intl = getCurrentIntl()
    throw new Error(intl.formatMessage({
      id: 'OwwJLXvTm54592guOZXH',
      defaultMessage: 'Invalid promo code for this deal',
      description: 'Error message when promo code is not valid for the current deal payment methods',
    }))
  }
}

export function verifyPromoOnAirlineCarriers(promotion: App.Promotion, state: App.State) {
  if (!promotion.allowedAirlineCarriers?.length) {
    return
  }
  const intl = getCurrentIntl()
  if (promotion.type !== 'fixed_amount') {
    throw new Error(intl.formatMessage({
      id: 'fT15VwmCc5Fg-Lmv77xo',
      defaultMessage: 'Promo code cannot be applied',
      description: 'Error message when promo code type is not applicable',
    }))
  }
  const journeys = getCartFlightJourneys(state)
  const allowedAirlineCarriers = new Set(promotion.allowedAirlineCarriers)
  const anyAirlineCarrierMatches = journeys.some(journey => {
    return journey.departing.flights.some((flight) => allowedAirlineCarriers.has(flight.carrier)) ||
      journey.returning?.flights.some((flight) => allowedAirlineCarriers.has(flight.carrier))
  })
  if (!anyAirlineCarrierMatches) {
    throw new Error(intl.formatMessage({
      id: 'VVrtpknS7ut4dzbfaIXO',
      defaultMessage: 'Promo code cannot be applied to selected airline',
      description: 'Error message when promo code airline carrier does not match',
    }))
  }
}

function verifyPromoOnCharterFlights(promotion: App.Promotion, state: App.State) {
  const isCharterFlightCheckout = getIsCharterFlightCheckout(state)
  if (isCharterFlightCheckout && promotion.code.toUpperCase() === EMPLOYEE20_PROMO_CODE) {
    const intl = getCurrentIntl()
    throw new Error(intl.formatMessage(
      {
        id: 'f1Cks6NXfBW3yzbzO_vT',
        defaultMessage: '{promoCode} cannot be applied to charter flights. Use {charterPromoCode} instead',
        description: 'Error message when employee promo code is used on charter flights instead of the charter-specific code',
      },
      { promoCode: 'EMPLOYEE20', charterPromoCode: 'EMPLOYEE_MALDIVES_CHARTER' },
    ))
  }
}

function applyPromotion(promotion: App.Promotion, dispatch: ThunkDispatch<App.State, undefined, DefinedAppAction>, hidePromoCode = false) {
  dispatch({
    type: CHECKOUT_APPLY_PROMO_CODE,
    promotion: { ...promotion, hidePromoCode },
  })
  dispatch({
    type: CHECKOUT_CLEAR_VELOCITY_BURN,
  })
  if (promotion.allowedPaymentMethods.length) {
    const intl = getCurrentIntl()
    showSnackbar(
      paymentMethodsToString(promotion.allowedPaymentMethods, intl),
      'success',
      {
        heading: intl.formatMessage({
          id: '1W_SYcptyyWgmTX4iHzZ',
          defaultMessage: 'Promo code applied',
          description: 'Snackbar heading when a promo code is successfully applied',
        }),
      },
    )
  }
}

export function resetPromoCode(): AppAction {
  return (dispatch, getState) => {
    dispatch({
      type: CHECKOUT_RESET_PROMO_CODE,
    })

    const { voucherIds } = getState().checkout.payment
    if (voucherIds?.length) {
      dispatch(addPromoCode(undefined, false, voucherIds))
    }
  }
}

// Clears any applied promo/voucher state immediately, then re-validates against the current
// cart. Used when landing on the final checkout page so stale discounts from a prior step
// (e.g. LuxPlus option change) are cleared and re-confirmed before the user pays.
export function refreshPromoCode(): AppAction {
  return (dispatch, getState) => {
    const { promoCode, voucherIds } = getState().checkout.payment
    if (!promoCode && (!voucherIds || voucherIds.length === 0)) return
    dispatch({ type: CHECKOUT_RESET_PROMO_CODE })
    // Deliberately not clearing voucherIds: addPromoCode is their only writer and sets them
    // on success, so clearing up-front loses them whenever the re-apply fails.
    dispatch(addPromoCode(promoCode, false, voucherIds?.length ? voucherIds : undefined))
  }
}

// Re-prices the applied promo/vouchers against the current cart while it may be about to be paid for.
// Unlike refreshPromoCode, the current discount stays applied while the request is in flight, so
// getPromoCodeItemDiscounts reports it as not ready and an order cannot be built from the stale
// discount, or from no discount at all after a reset. A rejected re-price still clears the discount
// rather than leaving the stale one applied.
export function revalidatePromoCode(): AppAction {
  return async(dispatch, getState) => {
    const { payment, promo } = getState().checkout
    const { promoCode, voucherIds } = payment
    if (!promoCode && (!voucherIds || voucherIds.length === 0)) return
    const request = dispatch(addPromoCode(promoCode, promo?.hidePromoCode, voucherIds?.length ? voucherIds : undefined))
    // addPromoCode flags its request (clearing fetchingPromoError) before its first await, and skips
    // the request when there is nothing to price, so only an error after a request is this re-price failing.
    const requested = !!getState().checkout.isFetchingPromo
    await request
    if (requested && getState().checkout.fetchingPromoError) {
      dispatch({ type: CHECKOUT_RESET_PROMO_CODE })
    }
  }
}

export function setRestoreCartStatus(
  status: App.CheckoutState['restoreCart']['status'],
  options?: {
    errorMsg?: string
    context?: App.RestoreCartErrorModalContext
    restoredCartId?: string
  },
): AppAction {
  return {
    type: CHECKOUT_SET_RESTORE_CART_STATUS,
    data: {
      status,
      ...options,
    },
  }
}

export function setCheckoutModifyFlightSearchView(view: App.CheckoutState['modifyFlightView']): AppAction {
  return {
    type: CHECKOUT_MODIFY_FLIGHT_SEARCH_VIEW,
    modifyFlightView: view,
  }
}

/** A Book click sent with GHA price match, and how far the price bedbank asked for sits from Google's. */
function logGhaBookClick(
  payload: CreateReservationEnquiryProps,
  outcome: 'enquired' | 'price_change' | 'failed',
  total?: number,
  calculationMethod?: string,
): AppAction {
  return (_dispatch, getState) => {
    if (!payload.gha) return
    const state = getState()
    const clickThrough = getGhaPriceMatch(state)
    // Checkout pages carry no click-through in the URL, so only a Book click on the hotel page gets a gap.
    const gha = clickThrough?.propertyId === payload.propertyId ? clickThrough : undefined
    const currency = state.geo.currentCurrency
    reportLog('Metasearch book click', {
      outcome,
      propertyId: payload.propertyId,
      roomTypeId: payload.roomTypeId,
      roomRateId: payload.roomRateId,
      checkIn: payload.checkIn,
      checkOut: payload.checkOut,
      occupancy: serialiseOccupancy(payload.rooms),
      sentPrice: payload.price + (payload.propertyFees ?? 0),
      price: total,
      calculationMethod,
      currency,
      googlePrice: gha?.googlePrice,
      googleCurrency: gha?.googleCurrency,
      priceGapToGooglePct: total === undefined ? undefined : getGapToGooglePct(total, currency, gha),
      inGoogleRoom: payload.roomTypeId === payload.gha.roomId,
    }, outcome === 'failed' ? 'warn' : 'info')
  }
}

export async function initBedbankSession(
  dispatch: AppDispatch,
  payload: CreateReservationEnquiryProps,
): Promise<Bedbank.CreateReservationEnquiryResponse | {
  price?: number
  luxplusPrice?: number
  propertyFees?: number
  validWithoutDiscount?: boolean
}> {
  try {
    const session = await enquiry(payload)
    dispatch(setBedbankEnquiry(session))
    dispatch(logGhaBookClick(payload, 'enquired', session.totals?.total, session.calculationMethod))
    return session
  } catch(error) {
    if (error.status === 422) {
      const priceChange = error.errors?.find((e: { code: string }) => e.code === 'price_change')
      if (priceChange) {
        dispatch(logGhaBookClick(payload, 'price_change', priceChange.price + (priceChange.propertyFees ?? 0)))
        return {
          price: priceChange.price,
          luxplusPrice: priceChange.luxplusPrice,
          propertyFees: priceChange.propertyFees,
          // Present only when the enquiry carried a loyalty package discount. `true` means the target
          // rate still clears margin at its own price and the discount caused the rejection.
          validWithoutDiscount: priceChange.validWithoutDiscount,
        }
      }
    }
    dispatch(logGhaBookClick(payload, 'failed'))
    throw error
  }
}

type BedbankSessionUpdateResult = {
  itemIds: Array<string>
  status: 'success' | 'failure'
}

function createBedbankSessionUpdateObserver(itemIds: Array<string>) {
  let resolveUpdate: ((result: BedbankSessionUpdateResult) => void) | undefined
  const promise = new Promise<BedbankSessionUpdateResult>((resolve) => { resolveUpdate = resolve })
  return {
    promise,
    onComplete: ({ status }: ApiActionResult<unknown>) => resolveUpdate?.({ itemIds, status }),
  }
}

export function updateBedbankSession(awaitItemId?: string): AppAction {
  return async function(dispatch, getState) {
    const state = getState()
    const viewsWithStatus = checkoutAccommodationOfferView(state)
    const sessionUpdates: Array<Promise<BedbankSessionUpdateResult>> = []

    for (const targetView of viewsWithStatus.data) {
      if (!isBedbankAccommodationOfferView(targetView)) {
        continue
      }

      if (!targetView.offerLoaded || !targetView.bedGroups.length) {
        continue
      }

      // Most items arrive here with a session already — from "Book now" on the offer page, or from
      // `refreshBedbankItemSessions` on the cart page — and are grouped by it.
      const groupedBySessionId = groupBy(targetView.itemViews, itemView => itemView.item.sessionId)
      const unenquiredItemViews = (groupedBySessionId.get(undefined) ?? [])
        .filter(({ item }) => hasPropertyRateLoyaltyUpgrade(item))
      groupedBySessionId.delete(undefined)

      // The offer page prefetches both sides of a loyalty package upgrade, but either enquiry can fail.
      // After the upgrade is toggled, an item may therefore use a rate with no session. Group these
      // items using the cart's first-enquiry key and create their initial sessions; otherwise checkout
      // would wait indefinitely for pricing that was never requested.
      const enquiryGroups: Array<[string | undefined, typeof unenquiredItemViews]> = [
        ...Array.from(groupedBySessionId.entries()) as Array<[string, typeof unenquiredItemViews]>,
        ...Array.from(groupBy(unenquiredItemViews, ({ item }) => getBedbankSessionGroupingKey(item)).values())
          .map((itemViews): [undefined, typeof unenquiredItemViews] => [undefined, itemViews]),
      ]

      for (const [oldSessionId, itemViews] of enquiryGroups) {
        const targetItem = itemViews[0].item
        const itemIds = itemViews.map(({ item }) => item.itemId)
        // For individual multi-room bookings, we expect each occupancy room to have its own bedbank
        // session, even if multiple occupancy rooms have the same mix of occupants and pick the
        // same hotel room type.
        const rooms = itemViews.map((v) => v.item.occupancy).filter(excludeNullOrUndefined)
        // svc-bedbank is enquired on its own un-marked basis: the item view's `price` is marked for
        // display, so it is read from the saved upgrade quote's base or the session's base instead.
        // Sending the marked price pairs it with a base-basis discount and re-marks it in checkout.
        // An applied upgrade books the TARGET rate but charges the source price; a removed upgrade
        // has fallen back to the source rate and enquires that.
        const session = oldSessionId ? state.checkout.sessions[oldSessionId]?.data : undefined
        const enquiryTotals = itemViews.map((itemView): BedbankEnquiryTotals => {
          const upgrade = itemView.item.loyaltyPropertyRateUpgrade
          const upgradePricing = isPropertyRateLoyaltyPackageUpgradeItem(itemView.item)
            ? upgrade?.targetPricing
            : upgrade?.sourcePricing
          if (upgradePricing) return getPropertyRatePricingEnquiryTotals(upgradePricing)
          return getBedbankSessionEnquiryTotals(session, itemView.item.occupancy, itemView.totals) ??
            getItemViewEnquiryTotals(itemView.totals)
        })
        const accomTotals = sum(enquiryTotals.map((totals) => totals.price))
        const accomMemberTotals = sum(enquiryTotals.map((totals) => totals.memberPrice))
        const propertyFees = sum(enquiryTotals.map((totals) => totals.propertyFees))
        const subscriber = getEnquirySubscriber(state)
        const isLuxPlusSubscriber = !!subscriber?.tier
        const discount = sum(itemViews, (itemView) => getPropertyRateUpgradeDiscount(itemView.item, isLuxPlusSubscriber) ?? 0) || undefined

        // GHA-404: a flagged session re-enquires without the price match the item was added with.
        const gha = isMetasearchPublicRateActive(state.marketing.metasearchPublicRateMarkedAt) ? undefined : targetItem.gha
        const priced = ghaPricedRequest(getSourceForProperty(state, targetView.offerId), gha)

        const enquiryParams = {
          propertyId: targetView.offerId,
          isFlightBundle: targetItem.isFlightBundle,
          rooms,
          roomTypeId: targetItem.roomId,
          roomRateId: targetItem.roomRateId,
          token: targetItem.token,
          bedGroupId: targetItem.bedGroupId,
          rateGroupId: targetItem.rateGroupId,
          region: state.geo.currentRegionCode,
          checkIn: targetView.startDate,
          checkOut: targetView.endDate,
          price: accomTotals,
          memberInclusive: accomMemberTotals,
          propertyFees,
          csBooking: state.auth.account.isSpoofed,
          subscriber,
          source: priced.source,
          gha: priced.gha,
          discount,
        }

        const observer = awaitItemId && itemIds.includes(awaitItemId)
          ? createBedbankSessionUpdateObserver(itemIds)
          : undefined
        dispatch({
          type: API_CALL,
          api: UPDATE_BEDBANK_SESSION,
          request: async() => {
            let response: Awaited<ReturnType<typeof initBedbankSession>>
            try {
              response = await initBedbankSession(dispatch, enquiryParams)
            } catch(error) {
              // Sold-out and blocked rates throw instead of returning a price-change body. If a
              // loyalty package upgrade is applied, record its target rejection without changing the
              // item. A source-rate failure has no applied upgrade and is handled below.
              const { cause } = dispatch(applyPropertyRateUpgradeRejection({ type: 'error', error }, oldSessionId, itemIds))
              // The target rate is unavailable, so show the ordinary sold-out modal after recording
              // the rejected loyalty package upgrade.
              if (cause === 'target-unavailable') {
                dispatch(bedbankSoldOutModalOpen())
              } else if (hasUnavailableCode(error) && itemViews.some(({ item }) => hasPropertyRateLoyaltyUpgrade(item))) {
                // The source rate became unavailable after the member removed their loyalty package
                // upgrade. The valid target session is still held, so offer to restore the upgrade.
                // `cause` is `unrelated` because the upgrade is no longer applied.
                dispatch(loyaltyUpgradeRejectedModalOpen({
                  outcome: 'source-unavailable',
                  bedbankSessionId: oldSessionId,
                  itemIds,
                }))
              }
              throw error
            }

            if (!('sessionId' in response)) {
              // Capture the source-price quote before rejection handling forfeits the loyalty package
              // upgrade and reprices the item to the target rate.
              const quotedPrice = getQuotedUpgradeTotal(itemViews, isLuxPlusSubscriber)
              const quotedPropertyFees = sum(itemViews, ({ totals }) => totals.otherFees?.propertyFees ?? 0)
              // Save the loyalty package upgrade metadata before rejection handling clears it.
              const upgradeSnapshots = itemViews.flatMap(({ item }) => {
                const upgrade = item.loyaltyPropertyRateUpgrade
                return upgrade
                  ? [{ item, upgrade }]
                  : []
              })
              const appliedUpgradeSnapshots = upgradeSnapshots.filter(({ item }) =>
                isPropertyRateLoyaltyPackageUpgradeItem(item),
              )
              const hasFeeMismatch = hasPropertyRateUpgradeFeeMismatch(
                itemViews.map(({ item }) => item),
                response.propertyFees,
              )
              const { cause, nonDiscountedPrice } = dispatch(applyPropertyRateUpgradeRejection({
                type: 'price-change',
                price: response.price,
                luxplusPrice: response.luxplusPrice,
                validWithoutDiscount: response.validWithoutDiscount,
              }, oldSessionId, itemIds))
              let shouldShowResolvedRecheck = true
              // A general price movement may leave the loyalty package upgrade valid at refreshed
              // prices. Re-check only that cause: a rejected discount will fail again, and an
              // unavailable target cannot be restored.
              if (cause === 'price-moved-regardless' && appliedUpgradeSnapshots.length) {
                // The re-check re-fetches availability and re-enquires, so give the member something
                // to look at rather than a few seconds of nothing.
                const reprice = { price: response.price, luxplusPrice: response.luxplusPrice, propertyFees: response.propertyFees }
                const recheckKey = buildRecheckKey(appliedUpgradeSnapshots[0].item.itemId, reprice)
                dispatch(loyaltyUpgradeRejectedModalOpen({
                  outcome: 'checking',
                  bedbankSessionId: oldSessionId,
                  recheckKey,
                }))
                const reapplied = await dispatch(recheckPropertyRateUpgradeAfterPriceChange({
                  ...appliedUpgradeSnapshots[0],
                  reprice,
                }))
                shouldShowResolvedRecheck = isLoyaltyUpgradeRecheckModalCurrent(getState().ui.modal, recheckKey)
                if (reapplied) {
                  // A retained loyalty package upgrade books the target at the refreshed source price.
                  // `response.price` is the target rate's own price and is not the customer's new total.
                  const sourceTotals = getPropertyRatePricingItemTotals(reapplied.sourcePricing)
                  if (shouldShowResolvedRecheck) {
                    dispatch(loyaltyUpgradeRejectedModalOpen({
                      outcome: 'upgrade-kept',
                      bedbankSessionId: oldSessionId,
                      quotedPrice,
                      newPrice: (isLuxPlusSubscriber && sourceTotals.memberPrice) || sourceTotals.price,
                      newLuxPlusPrice: sourceTotals.memberPrice || undefined,
                      oldPropertyFees: quotedPropertyFees,
                      propertyFees: sourceTotals.otherFees?.propertyFees,
                    }))
                  }
                  // The re-check already completed a replacement session update. Fail this stale
                  // request so its success handler cannot write an undefined session id. This relies
                  // on UPDATE_BEDBANK_SESSION having no failure handler.
                  throw new Error('Price is changed')
                }
              }
              // A removed upgrade enquires its source rate. If that source's property fees move away
              // from the target's, refresh availability before rejecting the pair: both sides may
              // have moved to the same fee and still satisfy accommodation's parity rule.
              if (cause === 'unrelated' && hasFeeMismatch && upgradeSnapshots.length) {
                const reprice = { price: response.price, luxplusPrice: response.luxplusPrice, propertyFees: response.propertyFees }
                const recheckKey = buildRecheckKey(upgradeSnapshots[0].item.itemId, reprice)
                dispatch(loyaltyUpgradeRejectedModalOpen({
                  outcome: 'checking',
                  bedbankSessionId: oldSessionId,
                  recheckKey,
                }))
                const refreshed = await dispatch(recheckPropertyRateUpgradeAfterPriceChange({
                  ...upgradeSnapshots[0],
                  reprice,
                  restoreAppliedUpgrade: false,
                }))
                const shouldShowResolvedSourceRecheck = isLoyaltyUpgradeRecheckModalCurrent(getState().ui.modal, recheckKey)
                if (refreshed) {
                  if (shouldShowResolvedSourceRecheck) {
                    dispatch(loyaltyUpgradeRejectedModalOpen({
                      outcome: 'source-repriced',
                      bedbankSessionId: oldSessionId,
                      itemIds,
                      quotedPrice,
                      newPrice: response.price,
                      newLuxPlusPrice: response.luxplusPrice,
                      oldPropertyFees: quotedPropertyFees,
                      propertyFees: response.propertyFees,
                    }))
                  }
                } else {
                  dispatch(applyPropertyRateUpgradeFeeMismatch(oldSessionId, itemIds))
                  if (shouldShowResolvedSourceRecheck) {
                    dispatch(loyaltyUpgradeRejectedModalOpen({
                      outcome: 'upgrade-lost-repriced',
                      bedbankSessionId: oldSessionId,
                      itemIds,
                      quotedPrice,
                      newPrice: response.price ?? (isLuxPlusSubscriber ? undefined : quotedPrice),
                      newLuxPlusPrice: response.luxplusPrice ?? (isLuxPlusSubscriber ? quotedPrice : undefined),
                      oldPropertyFees: quotedPropertyFees,
                      propertyFees: response.propertyFees,
                    }))
                  }
                }
                throw new Error('Price is changed')
              }
              // Both causes forfeit the loyalty package upgrade and keep the target at its own price.
              // A discount-only rejection shows a total; a general reprice shows before and after.
              if (cause === 'price-moved-regardless' && !shouldShowResolvedRecheck) {
                // The member dismissed or replaced the checking modal. Keep the background result,
                // but end this stale request without reopening its resolved outcome.
                throw new Error('Price is changed')
              }
              if (cause === 'upgrade-margin' || cause === 'price-moved-regardless') {
                dispatch(loyaltyUpgradeRejectedModalOpen({
                  outcome: cause === 'upgrade-margin' ? 'upgrade-lost' : 'upgrade-lost-repriced',
                  bedbankSessionId: oldSessionId,
                  quotedPrice,
                  ...getForfeitedUpgradeTotals({
                    price: response.price,
                    luxplusPrice: response.luxplusPrice,
                    nonDiscountedPrice,
                    isLuxPlusSubscriber,
                  }),
                  oldPropertyFees: quotedPropertyFees,
                  propertyFees: response.propertyFees,
                }))
              } else if (!oldSessionId && itemViews.some(({ item }) => hasPropertyRateLoyaltyUpgrade(item))) {
                // The source rate was repriced after the loyalty package upgrade was removed. It has no
                // session id, so identify the affected items directly and offer either the valid target
                // upgrade or the source rate's new price.
                dispatch(loyaltyUpgradeRejectedModalOpen({
                  outcome: 'source-repriced',
                  itemIds,
                  quotedPrice,
                  newPrice: response.price,
                  newLuxPlusPrice: response.luxplusPrice,
                  oldPropertyFees: quotedPropertyFees,
                  propertyFees: response.propertyFees,
                }))
              } else {
                // TODO: Guarantee there'll be a `<CheckoutModals/>` to render this modal.
                dispatch(bedbankHotelPriceChangeModalOpen({
                  // `newPrice` is unused for bedbank — the modal reads `newStandardPrice` /
                  // `newLuxPlusPrice` below.
                  newPrice: 0,
                  oldPrice: quotedPrice,
                  bedbankSessionId: oldSessionId,
                  newStandardPrice: response.price,
                  newLuxPlusPrice: response.luxplusPrice,
                  newPropertyFees: response.propertyFees,
                  isLuxPlusBooking: !!subscriber?.tier,
                }))
              }
              throw new Error('Price is changed')
            }
            // `itemIds` scopes the reducer update when there is no `oldSessionId`. Without them, every
            // unenquired bedbank item would match the missing session id.
            return { sessionId: response.sessionId, oldSessionId, itemIds }
          },
          sessionId: oldSessionId,
          ...(observer && { onComplete: observer.onComplete }),
        })
        if (observer) sessionUpdates.push(observer.promise)
      }
    }

    return Promise.all(sessionUpdates)
  }
}

export function updateHotelItemPricing(itemId: string, newPrice: number, surcharge?: { newSurcharge?: number, newExtraGuestSurcharge?: number }): AppAction {
  return {
    type: CHECKOUT_UPDATE_HOTEL_ITEM_PRICING,
    itemId,
    newPrice,
    surcharge,
  }
}

export function updateBundleItemPricing(itemId: string, offerId: string, newPrice: number, surcharge?: { newSurcharge?: number, newExtraGuestSurcharge?: number }): AppAction {
  return {
    type: CHECKOUT_UPDATE_BUNDLE_ITEM_PRICING,
    itemId,
    offerId,
    newPrice,
    surcharge,
  }
}

export function toggleCheckoutDevMode(): AppAction {
  return {
    type: CHECKOUT_TOGGLE_DEV_TOOLS,
  }
}

export function toggleCheckoutLoyaltyEnrolment(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const enrolLoyalty = state.checkout.loyalty.enrolCustomerAtCheckout
    dispatch({
      type: CHECKOUT_TOGGLE_LOYALTY_SIGNUP,
      enrolLoyalty: !enrolLoyalty,
    })
  }
}

export function setBedbankEnquiry(session: App.BedbankEnquiry): AppAction {
  return {
    type: SET_BEDBANK_SESSION,
    data: session,
  }
}

export function validateOfferDiscount(params: ValidateOfferDiscountParams): AppAction {
  return {
    type: API_CALL,
    api: CHECKOUT_VALIDATE_OFFER_DISCOUNT,
    request: () => validateOfferDiscountApi(params),
  }
}

export function checkoutFetchAndInitialiseBedbankChangeDates(orderId: string, orderItemId: string, reduceDatesOnly = false, conversationId?: string): AppAction {
  return (dispatch) => {
    dispatch({
      type: API_CALL,
      api: CHECKOUT_FETCH_BEDBANK_EXISTING_ORDER,
      request: async() => {
        const order = await getFullOrder(orderId)
        const orderItem = order.bedbankItems.find(i => i.id === orderItemId)

        if (orderItem) {
          const offerId = orderItem.offer.id
          const offer = await getOfferById(offerId, {
            region: order.regionCode,
          }) as App.BedbankOffer

          dispatch({
            type: API_CALL_SUCCESS,
            api: FETCH_BEDBANK_OFFER,
            data: offer,
            offerId,
          })

          const isFlightBundle = orderItem.rooms[0]?.isFlightBundle
          const roomsOptions = orderItem.rooms?.filter(room => room.status === 'booked').map(room => ({
            occupancy: room.occupancy,
            boardCode: room.boardCode,
            refundable: room.refundable,
            bedGroupId: room.bedGroup.id,
          }))
          const dates = {
            checkIn: moment(orderItem.checkIn).format(ISO_DATE_FORMAT),
            checkOut: moment(orderItem.checkOut).format(ISO_DATE_FORMAT),
            duration: orderItem.duration,
          }

          const items = generateBedbankChangeDatesAccommodationCheckoutItems({
            orderId: order.id,
            orderItemId: orderItem.id,
            offerId: orderItem.offer.id,
            roomId: orderItem.roomTypeId,
            roomRateId: orderItem.roomRateId,
            ...getBedbankChangeDatesBundleLinkage(orderItem),
            isFlightBundle,
            reduceDatesOnly,
            dates,
            roomsOptions,
          })

          dispatch(addToCheckoutCart([...items], {
            regionCode: order.regionCode,
            currencyCode: order.currencyCode,
            order,
            mode: 'change-dates',
            // LESA chat id from the deep link, so svc-order can tell LESA the change completed.
            conversationId,
          }))
        }
      },
    })
  }
}

export function initCheckoutBedbankChangeDatesSession(region: string, items: Array<App.Checkout.BedbankHotelItem>, isSpoofed: boolean): AppAction {
  return async(dispatch, getState) => {
    dispatch({
      type: API_CALL_REQUEST,
      api: CHECKOUT_INIT_BEDBANK_CHANGE_DATES_SESSION,
    })

    try {
      const data = await createCheckoutBedbankChangeDatesSession(dispatch, getState, region, items, isSpoofed)
      dispatch({
        type: API_CALL_SUCCESS,
        api: CHECKOUT_INIT_BEDBANK_CHANGE_DATES_SESSION,
        data,
      })

      return data
    } catch(error) {
      dispatch({
        type: API_CALL_FAILURE,
        api: CHECKOUT_INIT_BEDBANK_CHANGE_DATES_SESSION,
        error,
      })
      throw error
    }
  }
}

async function createCheckoutBedbankChangeDatesSession(
  dispatch: AppDispatch,
  getState: () => App.State,
  region: string,
  items: Array<App.Checkout.BedbankHotelItem>,
  isSpoofed: boolean,
) {
  const offerId = items[0].offerId
  const offer = await getOfferById(offerId, {
    region,
  }) as App.BedbankOffer

  const occupancy = items.map(item => item.occupancy)

  if (!offer) {
    throw new Error('Offer not found')
  }

  const updatedRatesRequest = {
    checkIn: items[0].checkIn,
    checkOut: items[0].checkOut,
    rooms: occupancy,
    region,
    isSpoofed,
  }
  const state = getState()
  const enablePropertyCollect = isPropertyCollectEnabled(state)
  const newRates = await getRatesForBedbankOffers([offer.id], updatedRatesRequest, enablePropertyCollect)
  const rate = newRates[0]?.rates.find(rate => rate.id === items[0].roomRateId)

  if (rate) {
    dispatch({
      type: API_CALL_SUCCESS,
      api: FETCH_BEDBANK_OFFERS_RATES,
      data: newRates,
      offerIds: [offer.id],
      filterKey: getBedbankRateKey(occupancy, items[0].checkIn, items[0].checkOut),
    })

    const session = await initBedbankSession(dispatch, {
      propertyId: offer.id,
      roomTypeId: items[0].roomId,
      roomRateId: rate.id,
      token: rate.token,
      rateGroupId: rate.groupId,
      isFlightBundle: items[0].isFlightBundle,
      region,
      rooms: occupancy,
      checkIn: items[0].checkIn,
      checkOut: items[0].checkOut,
      price: rate.totals.inclusive,
      memberInclusive: rate.totals.memberInclusive,
      propertyFees: rate.totals.propertyFees,
      csBooking: isSpoofed,
      subscriber: getEnquirySubscriber(state),
      source: SOURCE_TYPES.CHANGE_DATES,
    })

    if (!('sessionId' in session)) {
      throw new Error('Price is changed')
    }

    for (const item of items) {
      dispatch(updateCheckoutItem({
        ...item,
        sessionId: session.sessionId,
        bedGroupId: session.bedGroupId,
        token: rate.token,
        rateGroupId: rate.groupId,
      }))
    }
    return {
      sessionId: session.sessionId,
      defaultBedGroupId: session.bedGroupId,
    }
  }

  throw new Error('Room rate unavailable')
}

async function createBedbankSessionFromRate(
  dispatch: AppDispatch,
  params: {
    offer: App.BedbankOffer
    roomId: string
    rate: App.BedbankRate
    region: string
    rooms: Array<App.Occupants>
    checkIn: string
    checkOut: string
    isSpoofed: boolean
    state: App.State
    source?: string
  },
): Promise<{ sessionId: string; defaultBedGroupId: string; roomRateId: string; rateGroupId: string | undefined; token: string | undefined }> {
  const { offer, roomId, rate, region, rooms, checkIn, checkOut, isSpoofed, state, source } = params

  const session = await initBedbankSession(dispatch, {
    propertyId: offer.id,
    roomTypeId: roomId,
    roomRateId: rate.id,
    token: rate.token,
    rateGroupId: rate.groupId,
    isFlightBundle: rate.isFlightBundle,
    region,
    rooms,
    checkIn,
    checkOut,
    price: rate.totals.inclusive,
    memberInclusive: rate.totals.memberInclusive,
    propertyFees: rate.totals.propertyFees,
    csBooking: isSpoofed,
    subscriber: getEnquirySubscriber(state),
    source,
  })

  if (!('sessionId' in session)) {
    throw new Error('Price is changed')
  }

  return {
    sessionId: session.sessionId,
    defaultBedGroupId: session.bedGroupId,
    roomRateId: rate.id,
    rateGroupId: rate.groupId,
    token: rate.token,
  }
}

export async function initCheckoutBedbankSession(
  dispatch: AppDispatch,
  state: App.State,
  region: string,
  itemGroup: Array<App.Checkout.BedbankHotelItem>,
  isSpoofed: boolean,
): Promise<Array<{
  sessionId: string
  defaultBedGroupId: string
  roomRateId: string
  rateGroupId: string | undefined
  token: string | undefined
}>> {
  const item = itemGroup[0]
  const offerId = itemGroup[0].offerId
  const checkIn = itemGroup[0].checkIn
  const checkOut = itemGroup[0].checkOut
  const roomId = itemGroup[0].roomId
  const key = getBedbankSessionGroupingKey(itemGroup[0])
  const occupancies = itemGroup.map(item => item.occupancy)

  if (itemGroup.some(item => getBedbankSessionGroupingKey(item) !== key)) {
    throw new Error('Invalid items')
  }

  const markupSource = getChannelMarkupSource(state)

  const offer = await getOfferById(offerId, {
    region,
    markupSource,
  }) as App.BedbankOffer

  dispatch({
    type: API_CALL_SUCCESS,
    api: FETCH_BEDBANK_OFFER,
    data: offer,
    offerId,
  })

  if (!offer) {
    const intl = getCurrentIntl()

    throw new Error(intl.formatMessage({
      id: '3uEL4I88dBEGOXkL9DIg',
      defaultMessage: 'Offer not found',
      description: 'Error message thrown when a bedbank offer cannot be found while preparing checkout state',
    }))
  }

  const enablePropertyCollect = isPropertyCollectEnabled(state)

  // Primary path: try combined occupancies [2A, 2A]
  const combinedRatesRequest = {
    checkIn,
    checkOut,
    rooms: occupancies,
    region,
    isSpoofed,
    markupSource,
  }

  const combinedNewRates = await getRatesForBedbankOffers([offer.id], combinedRatesRequest, enablePropertyCollect)
  const combinedRates = combinedNewRates?.[0]?.rates
  const combinedRate = findBedbankRateMatchingItem(combinedRates, item)

  if (combinedRate) {
    dispatch({
      type: API_CALL_SUCCESS,
      api: FETCH_BEDBANK_OFFERS_RATES,
      data: combinedNewRates,
      offerIds: [offer.id],
      filterKey: getBedbankRateKey(occupancies, checkIn, checkOut),
    })

    const result = await createBedbankSessionFromRate(dispatch, {
      offer,
      roomId,
      rate: combinedRate,
      region,
      rooms: occupancies,
      checkIn,
      checkOut,
      isSpoofed,
      state,
      source: SOURCE_TYPES.INIT_CHECKOUT,
    })
    return itemGroup.map(() => result)
  }

  // Fallback path: fetch rates per room with [2A] individually
  const uniqueOccupancyEntries = [...new Map<string, App.Checkout.BedbankHotelItem>(
    itemGroup.map(gi => [getBedbankRateKey([gi.occupancy], checkIn, checkOut), gi]),
  ).entries()]

  const ratesByOccupancyKey = new Map<string, { rates: Array<App.BedbankRate>, newRates: typeof combinedNewRates }>()

  await Promise.all(uniqueOccupancyEntries.map(async([perRoomKey, groupItem]) => {
    const perRoomRatesRequest = {
      checkIn,
      checkOut,
      rooms: [groupItem.occupancy],
      region,
      isSpoofed,
      markupSource,
    }

    const perRoomNewRates = await getRatesForBedbankOffers([offer.id], perRoomRatesRequest, enablePropertyCollect)
    const perRoomRates = perRoomNewRates?.[0]?.rates ?? []
    ratesByOccupancyKey.set(perRoomKey, { rates: perRoomRates, newRates: perRoomNewRates })

    dispatch({
      type: API_CALL_SUCCESS,
      api: FETCH_BEDBANK_OFFERS_RATES,
      data: perRoomNewRates,
      offerIds: [offer.id],
      filterKey: perRoomKey,
    })
  }))

  const results: Array<{ sessionId: string; defaultBedGroupId: string; roomRateId: string; rateGroupId: string | undefined; token: string | undefined }> = []

  for (const groupItem of itemGroup) {
    const perRoomKey = getBedbankRateKey([groupItem.occupancy], checkIn, checkOut)
    const cached = ratesByOccupancyKey.get(perRoomKey)
    const rates = cached?.rates

    const rate = findBedbankRateMatchingItem(rates, groupItem)

    if (!rate) {
      throw new Error('Room rate unavailable')
    }

    const result = await createBedbankSessionFromRate(dispatch, {
      offer,
      roomId,
      rate,
      region,
      rooms: [groupItem.occupancy],
      checkIn,
      checkOut,
      isSpoofed,
      state,
      source: SOURCE_TYPES.INIT_CHECKOUT,
    })

    results.push(result)
  }

  return results
}

export function updateArrivalFlightNumber(flightNumber: string): AppAction {
  return {
    type: CHECKOUT_UPDATE_ARRIVAL_FLIGHT_NUMBER,
    data: flightNumber,
  }
}

export function updateAgentInformation(agent: App.AgentDetails): AppAction {
  return {
    type: CHECKOUT_AGENT_BOOKING_DETAILS,
    data: agent,
  }
}

export function updateCsDepositPercentageOverride(depositOverride: boolean): AppAction {
  return {
    type: CHECKOUT_UPDATE_CS_DEPOSIT_OVERRIDE,
    depositOverride,
  }
}

export function setMerchantFeePaymentType(paymentType: App.MerchantFeePaymentType | null): AppAction {
  return {
    type: CHECKOUT_SET_MERCHANT_FEE_PAYMENT_TYPE,
    paymentType,
  }
}

export function setSplitMerchantFeeAmount(amount: number | null): AppAction {
  return {
    type: CHECKOUT_SET_SPLIT_MERCHANT_FEE_AMOUNT,
    amount,
  }
}

export function setInlineSplitActive(isActive: boolean): AppAction {
  return {
    type: CHECKOUT_SET_INLINE_SPLIT_ACTIVE,
    isActive,
  }
}

export function setSplitCardLegs(legs: App.CheckoutState['splitPayment']['legs']): AppAction {
  return {
    type: CHECKOUT_SET_SPLIT_CARD_LEGS,
    legs,
  }
}

export function setSplitNewCardDetails(
  newCardDetailsByLegId: App.CheckoutState['splitPayment']['newCardDetailsByLegId'],
): AppAction {
  return {
    type: CHECKOUT_SET_SPLIT_NEW_CARD_DETAILS,
    newCardDetailsByLegId,
  }
}

export function setPayPalPaymentType(paymentType: typeof PAYPAL_PAYMENT_TYPE | typeof PAYLATER_PAYMENT_TYPE): AppAction {
  return {
    type: SET_PAYPAL_PAYMENT_TYPE,
    paymentType,
  }
}

export function logPaymentEvent(event: App.PaymentEventLog) {
  return {
    type: API_CALL,
    api: LOG_PAYMENT_EVENT,
    request: () => postPaymentEventLog(event as PaymentEventLogRequest),
  }
}

/**
 * Removes the given subscription item (lux plus) from the cart
 *
 * Also removes the associated join fee item if it exists
 * @param itemId
 */
export function removeSubscriptionItem(itemId: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const joinFeeItem = getSubscriptionJoinItems(state).find(item => item.subscriptionItemId === itemId)
    if (joinFeeItem) {
      dispatch(removeItem(joinFeeItem.itemId))
    }
    dispatch(removeItem(itemId))
  }
}

export function createStripePaymentMethod(stripe: Stripe, options: CreatePaymentMethodFromElements) {
  return {
    type: API_CALL,
    api: CREATE_STRIPE_PAYMENT_METHOD,
    request: async() => {
      const intl = getCurrentIntl()
      const paymentMethodResponse = await stripe.createPaymentMethod(options)

      if (!paymentMethodResponse?.paymentMethod) {
        showSnackbar(intl.formatMessage({
          id: 'qTWi7MXv2O032TkGvPT8',
          defaultMessage: 'Invalid card. Please check your card details and try again.',
          description: 'Snackbar message when Stripe card validation fails at checkout',
        }), 'critical')
      }
      return paymentMethodResponse
    },
  }
}

export function setStripePaymentMethod(paymentMethod: Partial<App.StripePaymentMethod>): AppAction {
  return {
    type: CHECKOUT_SET_STRIPE_PAYMENT_METHOD,
    paymentMethod,
  }
}

/**
 * Sets the checkout displayed payment method.
 * Pass `undefined` to mark unset (e.g. on unmount); `null` for explicit no selection.
 */
export function setCheckoutDisplayedPaymentMethod(paymentMethod: PaymentMethod | null | undefined): AppAction {
  return {
    type: CHECKOUT_SET_DISPLAYED_PAYMENT_METHOD,
    paymentMethod,
  }
}

export function createCartQuote(cartId: string, callbackDate?: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const quoteStatus = state.checkout.cart.csCartQuoteStatus
    if (quoteStatus === 'created' || quoteStatus === 'loading') return

    /*
      * When spoofing from admin, the utm_medium can be either 'admin' or 'popup_store'
      * 'popup_store' indicates the cs agent is from the Chadstone store
      * 'admin' indicates the cs agent is from the call center
      * When the quote is created on Agent Hub, we don't want to store utms on svc-cart,
        that's why we only pass utms when spoofing from admin
    */
    const utms = state.utm.campaign === 'spoof' ? [state.utm.medium] : undefined

    dispatch({
      type: API_CALL,
      api: CHECKOUT_CREATE_CART_QUOTE,
      request: () => createQuoteFromCart(cartId, callbackDate, utms),
    })
  }
}

export function updateCartQuote(keys: QuoteDedupeKeys, callbackDate?: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const { csCartQuoteStatus, csCartQuoteId } = state.checkout.cart
    if (csCartQuoteStatus !== 'created' || !csCartQuoteId) return
    dispatch({
      type: API_CALL,
      api: CHECKOUT_UPDATE_CART_QUOTE,
      request: () => updateQuoteFromCart(csCartQuoteId, keys, callbackDate),
    })
  }
}

export function addArrivalDetails(itemId: string, arrivalDetails: App.ArrivalDetails): AppAction {
  return {
    type: CHECKOUT_ADD_ARRIVAL_DETAILS,
    itemId,
    arrivalDetails,
  }
}

export function setArrivalDetailsTime(itemId: string, arrivalTime: string): AppAction {
  return {
    type: CHECKOUT_SET_ARRIVAL_DETAILS_TIME,
    itemId,
    arrivalTime,
  }
}

export function setArrivalDetailsFlightNumber(itemId: string, arrivalFlightNumber: string): AppAction {
  return {
    type: CHECKOUT_SET_ARRIVAL_DETAILS_FLIGHT_NUMBER,
    itemId,
    arrivalFlightNumber,
  }
}

interface InitialiseMobileCheckoutParams {
  originAirportCode: string
  offerId: string
  checkIn: string
  packageId: string
  numberOfNights: number
  occupancy: Array<App.Occupants>
  roomRateId: string
  destinationAirportCode: string
  flightQuotedPrice?: number
  luxPlusOfferId?: string
  loyaltyStayUpgradeType?: App.LoyaltyStayUpgradeType
}

export function initialiseMobileFlightCheckout(data: InitialiseMobileCheckoutParams): AppAction {
  const {
    offerId,
    originAirportCode,
    checkIn,
    numberOfNights,
    packageId,
    roomRateId,
    occupancy,
    destinationAirportCode,
    flightQuotedPrice,
    luxPlusOfferId,
    loyaltyStayUpgradeType,
  } = data

  return async(dispatch, getState) => {
    const state = getState()
    const { geo, auth } = state
    const { currentRegionCode } = geo
    const markupSource = getChannelMarkupSource(state)
    const intl = getCurrentIntl()

    const offer = (await getOfferById(offerId, {
      region: currentRegionCode,
      flightOrigin: originAirportCode,
      markupSource,
    })) as App.Offer | App.BedbankOffer

    if (!offer) {
      throw new CartInitError({
        type: 'unrecoverable_offer_error',
        code: 'offer_not_found',
        message: intl.formatMessage({
          id: 'mDlBj-BKr0ivLH8vYw2z',
          defaultMessage: 'Offer not found',
          description: 'Error message shown when an offer cannot be found while initialising checkout cart items',
        }),
      })
    }
    const checkOut = moment(checkIn).add(numberOfNights, 'days').format(ISO_DATE_FORMAT)

    const luxPlusEnabled = getIsLuxPlusEnabled(state)
    let luxPlusSubscriptionItems: Array<App.Checkout.LuxPlusSubscriptionItem | App.Checkout.SubscriptionJoinItem> = []
    if (luxPlusEnabled && luxPlusOfferId) {
      try {
        const luxPlusOffers = await getSubscriptionOffer(currentRegionCode)
        const luxPlusOffer = luxPlusOffers?.find(offer => offer.id === luxPlusOfferId)

        if (!luxPlusOffer) {
          throw new CartInitError({
            type: 'unrecoverable_offer_error',
            code: 'offer_not_found',
            message: intl.formatMessage({
              id: 'MTl5vUlraLZZhtlYCPAF',
              defaultMessage: 'LuxPlus offer not found',
              description: 'Error message shown when a LuxPlus offer cannot be found while initialising checkout cart items',
            }),
          })
        }

        luxPlusSubscriptionItems = generateLuxPlusSubscriptionItems(luxPlusOffer)
      } catch(error) {
        throw new CartInitError({
          type: 'unrecoverable_offer_error',
          code: 'offer_not_found',
          message: intl.formatMessage(
            {
              id: 'piMDJo5sRZQQs0YODLIl',
              defaultMessage: 'Error occurred while fetching LuxPlus offer {errorMessage}',
              description: 'Error message shown when fetching a LuxPlus offer fails during checkout cart initialisation',
            },
            { errorMessage: error.message },
          ),
        })
      }
    }
    // addToCheckoutCart needs to happen before the enquiry to populate subscriber data in the session
    dispatch(addToCheckoutCart(luxPlusSubscriptionItems))

    if (offer.type === 'bedbank_hotel') {
      const authState: App.AuthState = state.auth

      const updatedRatesRequest = {
        checkIn,
        checkOut,
        rooms: occupancy,
        region: currentRegionCode,
        id: offerId,
        timezone: offer.property.timezone,
        isSpoofed: authState.account.isSpoofed,
        markupSource: getChannelMarkupSource(state),
        channelMarkupLeadSell: getBedbankOfferChannelMarkupLeadSell(offer),
      }

      const newRates = await getRatesForBedbankOffer(updatedRatesRequest)
      let rate: App.BedbankRate | undefined
      if (!packageId) {
        rate = newRates[0]
      } else if (!roomRateId) {
        rate = newRates.find(rate => rate.roomId === packageId)
      } else {
        rate = newRates.find(rate => rate.roomId === packageId && rate.id === roomRateId)
      }

      if (!rate) {
        throw new Error('Rate not found')
      }

      const session = await initBedbankSession(dispatch, {
        propertyId: offer.id,
        roomTypeId: rate.roomId,
        roomRateId: rate.id,
        token: rate.token,
        rateGroupId: rate.groupId,
        isFlightBundle: rate.isFlightBundle,
        region: currentRegionCode,
        rooms: occupancy,
        checkIn,
        checkOut,
        price: rate.totals.inclusive,
        memberInclusive: rate.totals.memberInclusive,
        propertyFees: rate.totals.propertyFees,
        csBooking: auth.account.isSpoofed,
        subscriber: getEnquirySubscriber(state),
        source: SOURCE_TYPES.INIT_MOBILE_FLIGHT_CHECKOUT,
      })
      if (!('sessionId' in session)) {
        throw new Error('Price is changed')
      }
      const accommodationItems: Array<App.Checkout.BedbankHotelItem> =
        occupancy.map((occupancy) => {
          const accommodation: App.Checkout.BedbankHotelItem = {
            itemId: uuidV4(),
            offerId: offer.id,
            transactionKey: uuidV4(),
            itemType: CHECKOUT_ITEM_TYPE_BEDBANK,
            roomRateId,
            duration: numberOfNights,
            occupancy,
            checkIn,
            checkOut,
            token: rate.token,
            rateGroupId: rate.groupId,
            bedGroupId: rate.bedGroups[0].id,
            isFlightBundle: rate.isFlightBundle,
            roomId: packageId,
            sessionId: session.sessionId,
          }

          return accommodation
        })

      const rooms = accommodationItems.map((item) => item.occupancy)
      const flightOccupants = countOccupantsForFlights(rooms)

      const flightItem = generateFlightCheckoutItem({
        originAirportCode,
        destinationAirportCode,
        bundledItemIds: accommodationItems.map((item) => item.itemId),
        occupants: flightOccupants,
        fareType: 'return',
        viewType: FlightViewTypes.TWO_ONE_WAYS,
        passengers: generatePassengersFromOccupants(flightOccupants),
        quotedFare: flightQuotedPrice,
      })

      dispatch(addItems([...accommodationItems, flightItem]))
    } else {
      const pkg = getPackageFromOffer(offer, packageId, numberOfNights)

      if (!pkg) {
        throw new Error('No Package found')
      }

      let loyaltyUpgradePkg: App.Package | undefined
      if (loyaltyStayUpgradeType) {
        const targetUpgradePackageUniqueKey = pkg.loyalty.upgradeTargetsUniqueKeys?.[loyaltyStayUpgradeType]
        loyaltyUpgradePkg = targetUpgradePackageUniqueKey ? offer.packages.find(pkg => pkg.uniqueKey === targetUpgradePackageUniqueKey) : undefined
        if (!loyaltyUpgradePkg) {
          throw new Error(`Loyalty ${loyaltyStayUpgradeType} upgrade not found`)
        }
      }

      const accommodationItems =
        occupancy.map((occupancy): App.Checkout.InstantBookingLEHotelItem => ({
          itemId: uuidV4(),
          offerId: offer.id,
          transactionKey: uuidV4(),
          itemType: CHECKOUT_ITEM_TYPE_LE_HOTEL,
          reservationType: 'instant_booking',
          packageId: loyaltyUpgradePkg ? loyaltyUpgradePkg.id : packageId,
          roomRateId: loyaltyUpgradePkg ? loyaltyUpgradePkg.roomRate!.id : roomRateId,
          duration: numberOfNights,
          occupancy,
          checkIn,
          checkOut,
        }))

      const rooms = accommodationItems.map((item) => item.occupancy)
      const flightOccupants = countOccupantsForFlights(rooms)

      const flightItem = generateFlightCheckoutItem({
        originAirportCode,
        destinationAirportCode,
        bundledItemIds: accommodationItems.map((item) => item.itemId),
        occupants: flightOccupants,
        fareType: 'return',
        viewType: FlightViewTypes.TWO_ONE_WAYS,
        passengers: generatePassengersFromOccupants(flightOccupants),
        quotedFare: flightQuotedPrice,
      })

      dispatch(addItems([...accommodationItems, flightItem]))
    }
  }
}

export function activateRebooking(rebookingID: string): AppAction {
  return {
    type: ACTIVATE_REBOOKING,
    data: { rebookingID },
  }
}

export function activatePaymentScheduleRebooking(
  paymentScheduleRebookingId: string,
  scheduleTemplateId?: string,
  selectedFrequency?: 'weekly' | 'fortnightly' | 'monthly' | null,
  supplierPaymentNumberOfDays?: number,
): AppAction {
  return {
    type: ACTIVATE_PAYMENT_SCHEDULE_REBOOKING,
    data: { paymentScheduleRebookingId, scheduleTemplateId, selectedFrequency, supplierPaymentNumberOfDays },
  }
}

export function clearPaymentScheduleRebooking(): AppAction {
  return {
    type: CLEAR_PAYMENT_SCHEDULE_REBOOKING,
  }
}

export function fetchCommissionPromoCode(force?: boolean): AppAction {
  return (dispatch, getState) => {
    if (!config.agentHub.isEnabled) {
      return
    }
    const state = getState()
    const regionCode = state.geo.currentRegionCode

    const commissionCartItems = stateToCommissionOrder(state)
    const isAncillaryPayment = isPostPurchaseAncillaryPayment(state)
    const hasBedbankItemMissingMx = commissionCartItems.items.some(item => item.type === OFFER_TYPE_BED_BANK && !item.mx)

    if (isAncillaryPayment || hasBedbankItemMissingMx) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_COMMISSION_PROMO_CODE,
      request: () => getAgentHubCommissionPromoCode(regionCode, commissionCartItems, force),
    })
  }
}

export function setPayToBankSelected(selectedPayToBank: App.PayToSupportedBank): AppAction {
  return {
    type: CHECKOUT_SET_PAYTO_BANK,
    selectedPayToBank,
  }
}

export function setCommsResubscribe(commsResubscribe: boolean): AppAction {
  return {
    type: CHECKOUT_SET_COMMS_RESUBSCRIBE,
    commsResubscribe,
  }
}

export function resubscribeUserForComms(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    if (!state.checkout.form.commsResubscribe || !state.auth.account.memberId) return
    const isLuxPlus = getHasLuxPlusOrSubscriptionInCart(state)
    dispatch(updateLESubscriptionsV2({
      userId: state.auth.account.memberId,
      subscriptions: {
        smsSubscribed: true,
        emailSubscribed: true,
        appPushSubscribed: true,
        myJourneySubscribed: true,
        todaysEscapesSubscribed: true,
        curatedCollectionSubscribed: true,
        todaysEscapesCadence: 'DAILY',
      },
      source: SubscriptionSource.CHECKOUT_PAGE,
    }))
    trackClientEvent({
      subject: isLuxPlus ? 'personalised-weekly-luxplus' : 'personalised-weekly',
      action: 'checkout',
      type: 'interaction',
      category: 'resubscribe',
    })
  }
}

export function generatePaymentLink(smsMessageTravellerName?: string, sendToMobileNumber?: string): AppAction {
  return (dispatch: AppDispatch, getState: () => App.State) => {
    const state = getState()
    const intl = getCurrentIntl()

    dispatch({
      type: CHECKOUT_FETCHING_PAYMENT_LINK,
    })

    if (!state.checkout.orderId) {
      // adding timeout to show the error modal after the processing modal
      setTimeout(() => {
        dispatch({
          type: CHECKOUT_FETCHING_PAYMENT_LINK_FAILED,
        })
        dispatch(processingCancel())
        dispatch(genericOrderErrorModalOpen([intl.formatMessage({
          id: 'qQcs0qrg7xAG3v4Kme0J',
          defaultMessage: 'Unable to generate payment link',
          description: 'Error message displayed in modal when payment link generation fails',
        })]))
      }, 3000)
      return
    }

    const payload = {
      orderId: state.checkout.orderId,
      region: state.geo.currentRegionCode as Region,
      metadata: {
        itemNames: [] as Array<string>,
      },
      sendToMobileNumber,
      smsMessageTravellerName,
    }

    // brand is added by the request preprocessor
    const payloadWithoutBrand = payload as CreatePaymentLinkPayload

    createPaymentLink(payloadWithoutBrand)
      .then((paymentLink) => {
        dispatch({
          type: CHECKOUT_SET_PAYMENT_LINK,
          data: {
            securePaymentLink: paymentLink,
            securePaymentLinkType: sendToMobileNumber ? SECURE_PAYMENT_OPTIONS.LINK_VIA_SMS : SECURE_PAYMENT_OPTIONS.LINK_STANDALONE,
          },
        })
        dispatch(showSecurePaymentModal())
      })
      .catch(() => {
        dispatch({
          type: CHECKOUT_FETCHING_PAYMENT_LINK_FAILED,
        })
        dispatch(processingCancel())
        dispatch(genericOrderErrorModalOpen([intl.formatMessage({
          id: 'qQcs0qrg7xAG3v4Kme0J',
          defaultMessage: 'Unable to generate payment link',
          description: 'Error message displayed in modal when payment link generation fails',
        })]))
      })
  }
}

export function setPaymentProgressStep(step: number): AppAction {
  return {
    type: CHECKOUT_SET_PAYMENT_PROGRESS_STEP,
    step,
  }
}

export function setPaymentProgressFailed(): AppAction {
  return {
    type: CHECKOUT_SET_PAYMENT_PROGRESS_FAILED,
  }
}

export function setOrderId(orderId: string): AppAction {
  return {
    type: CHECKOUT_SET_ORDER_ID,
    orderId,
  }
}

export function setCheckoutCartMode(mode: App.CheckoutCartMode): AppAction {
  return {
    type: CHECKOUT_SET_MODE,
    mode,
  }
}

export function setHasCarHireIntention(hasCarHireIntention: boolean): AppAction {
  return {
    type: CHECKOUT_SET_HAS_CAR_HIRE_INTENTION,
    hasCarHireIntention,
  }
}

export function setAgentHubPaymentSetup(agentHubPaymentMode: App.AgentHubPaymentMode): AppAction {
  return {
    type: CHECKOUT_SET_AGENT_HUB_PAYMENT_SETUP,
    agentHubPaymentMode,
  }
}

function applyTransferDiscountFlags(
  item: App.Checkout.ExperienceItem,
  ticketId: string,
): { nextItem: App.Checkout.ExperienceItem; changed: boolean } {
  let changed = false

  const tickets = item.tickets.map(ticket => {
    const shouldDiscount = ticket.ticketId === ticketId
    if (ticket.loyaltyTransferDiscount === shouldDiscount) {
      return ticket
    }

    changed = true
    return {
      ...ticket,
      loyaltyTransferDiscount: shouldDiscount,
    }
  })

  return {
    nextItem: changed ? { ...item, tickets } : item,
    changed,
  }
}

export function setLoyaltyDiscountOnTransferItem(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const transferItem = getExperienceItems(state)[0]
    if (!transferItem) {
      return
    }

    const { experienceToTicketId } = getTransferOfferLookup(state.loyalty.config?.transferOffers)

    const ticketId = experienceToTicketId.get(transferItem.experienceId)
    if (!ticketId) {
      return
    }

    const { nextItem, changed } = applyTransferDiscountFlags(transferItem, ticketId)
    if (changed) {
      dispatch(updateCheckoutItem(nextItem))
    }
  }
}

export function refetchCommissionPromoCode() {
  return (dispatch: AppDispatch) => {
    dispatch(resetCheckoutCommission())
    dispatch(fetchCommissionPromoCode(true))
  }
}

export function restoreCheckoutLoyaltyPointsToBurn(pointsToBurn: number | undefined): AppAction {
  return {
    type: CHECKOUT_RESTORE_LOYALTY_UPDATE_POINTS_TO_BURN,
    pointsToBurn,
  }
}

export function restoreCheckoutPromoCode(promoCode: string): AppAction {
  return (dispatch) => {
    dispatch(addPromoCode(promoCode))
    dispatch({
      type: CHECKOUT_CLEAR_RESTORED_PROMO_CODE,
    })
  }
}

export function restoreCheckoutUseCredit(useCredit: boolean): AppAction {
  return (dispatch) => {
    dispatch(setUsingCredit(useCredit))
    dispatch({
      type: CHECKOUT_CLEAR_RESTORED_USE_CREDIT,
    })
  }
}

export function toggleFailedItems(): AppAction {
  return {
    type: CHECKOUT_TOGGLE_FAILED_ITEMS,
  }
}

export function updateCheckoutLoyaltyPointsToBurn(pointsToBurn: number | undefined): AppAction {
  return (dispatch) => {
    dispatch({
      type: CHECKOUT_LOYALTY_UPDATE_POINTS_TO_BURN,
      pointsToBurn,
    })
  }
}

export function applyCheckoutLoyaltyRoomUpgrade(
  item: App.Checkout.LEAccommodationItem,
  upgradeType: App.LoyaltyStayUpgradeType | undefined,
): AppAction {
  return (dispatch) => {
    const updatedItem: App.Checkout.LEAccommodationItem = {
      ...item,
      loyaltyAppliedUpgradeType: upgradeType,
      loyaltyBasePackageId: upgradeType ? item.packageId : undefined,
    }
    dispatch(updateCheckoutItem(updatedItem))
  }
}

export function toggleCheckoutLoyaltyPropertyRateUpgrade(
  item: App.Checkout.InstantBookingLEHotelItem | App.Checkout.BedbankHotelItem,
): AppAction {
  return (dispatch) => {
    dispatch(updateCheckoutItem(buildToggledPropertyRateItem(item)))
  }
}

function recordRejectedUpgrade(item: App.Checkout.BedbankHotelItem): void {
  const upgrade = item.loyaltyPropertyRateUpgrade
  if (!upgrade) return
  recordRejectedPropertyRateUpgrade({
    propertyId: upgrade.target.propertyId,
    sourceRateId: upgrade.source.serviceRateId,
    targetRateId: upgrade.target.serviceRateId,
    checkIn: item.checkIn,
    checkOut: item.checkOut,
    occupancy: item.occupancy,
  })
}

/**
 * Handle a rejected loyalty package upgrade and classify the bedbank failure.
 *
 * Used by checkout-entry enquiries and payment order creation. This function updates checkout state
 * but leaves modal timing to each caller. Scope handling by `sessionId` when one exists, or by
 * `itemIds` for a checkout-entry enquiry that has not created a session yet.
 *
 * Return the target's own price before forfeiting clears `targetPricing`, allowing callers to show the
 * new payable total.
 */
export function applyPropertyRateUpgradeRejection(
  failure: EnquiryFailure,
  sessionId?: string,
  itemIds: Array<string> = [],
): ThunkAction<{ cause: UpgradeFailureCause, nonDiscountedPrice: number }, App.State, undefined, DefinedAppAction> {
  return (dispatch, getState) => {
    const state = getState()
    // Only bedbank items have an enquiry to reject, and narrowing here keeps `itemViews` one type.
    const upgradedItems = checkoutAccommodationOfferView(state).data
      .filter(isBedbankAccommodationOfferView)
      .flatMap((view) => view.itemViews)
      .map(({ item }) => item)
      .filter(isPropertyRateLoyaltyPackageUpgradeItem)
      .filter((item) => sessionId ? item.sessionId === sessionId : itemIds.includes(item.itemId))

    const isLuxPlusSubscriber = !!getEnquirySubscriber(state)?.tier
    // Use the same public/member basis as the loyalty package upgrade discount. A missing LuxPlus+
    // price falls back to the target rate's public price.
    const nonDiscountedPrice = sum(upgradedItems, (item) => {
      const targetPricing = item.loyaltyPropertyRateUpgrade?.targetPricing
      return targetPricing ? getPropertyRatePricingSellingPrice(targetPricing, isLuxPlusSubscriber) : 0
    })

    const cause = resolveUpgradeFailure(failure, {
      hasUpgradeApplied: upgradedItems.length > 0,
      nonDiscountedPrice,
      isLuxPlusSubscriber,
    })
    if (cause === 'unrelated') return { cause, nonDiscountedPrice }

    // Keep an unavailable target on the item because the sold-out modal returns the member to the
    // offer page. For price failures, remove the loyalty package upgrade and keep the target at its
    // own price.
    const shouldForfeit = cause !== 'target-unavailable'

    for (const item of upgradedItems) {
      // Temporarily hide the rejected loyalty package upgrade for this stay and rate pair.
      recordRejectedUpgrade(item)
      if (shouldForfeit) {
        dispatch(forfeitCheckoutLoyaltyPropertyRateUpgrade(item))
      }
    }
    return { cause, nonDiscountedPrice }
  }
}

/**
 * Remove a package-upgrade relation after a property-fee change confirms that source and target no
 * longer satisfy accommodation's fee-parity rule. Unlike a discount rejection, this can affect the
 * source item while the upgrade is removed, so match any item carrying the relation.
 */
export function applyPropertyRateUpgradeFeeMismatch(
  sessionId?: string,
  itemIds: Array<string> = [],
): AppAction {
  return (dispatch, getState) => {
    const items = checkoutAccommodationOfferView(getState()).data
      .filter(isBedbankAccommodationOfferView)
      .flatMap((view) => view.itemViews)
      .map(({ item }) => item)
      .filter((item): item is App.Checkout.BedbankHotelItem => item.itemType === 'bedbankHotel')
      .filter(hasPropertyRateLoyaltyUpgrade)
      .filter((item) => sessionId ? item.sessionId === sessionId : itemIds.includes(item.itemId))

    for (const item of items) {
      recordRejectedUpgrade(item)
      dispatch(forfeitCheckoutLoyaltyPropertyRateUpgrade(item))
    }
  }
}

/**
 * Accept a repriced bedbank rate: write bedbank's new pricing into offer state, then re-enquire.
 *
 * The write is not optional. The enquiry payload is built from the item's totals, so without it the
 * fresh enquiry goes out at the price bedbank has just refused and fails the same way. Shared by the
 * price-change modal and the loyalty package upgrade rejection modal. Read the cart directly because
 * a failed session leaves the accommodation view incomplete.
 *
 * A rate nobody has enquired has no session id to be found by, so those items are named by `itemIds`.
 */
export function acceptBedbankPriceChange(
  priceChange: Pick<App.UiPriceChangeModalState, 'bedbankSessionId' | 'newStandardPrice' | 'newLuxPlusPrice' | 'newPropertyFees'> & {
    /** Which items to reprice when there is no session id — a rate nobody has enquired. */
    itemIds?: Array<string>
  },
): AppAction {
  return (dispatch, getState) => {
    const { bedbankSessionId, itemIds } = priceChange
    if (!bedbankSessionId && !itemIds?.length) return

    const items = getState().checkout.cart.items
      .filter(isBedbankItem)
      .filter((item) => bedbankSessionId ? item.sessionId === bedbankSessionId : !!itemIds?.includes(item.itemId))
    const rooms = items.map(({ occupancy }) => occupancy).filter(excludeNullOrUndefined)
    // Never partially reprice an enquiry group: every bedbank item should carry an occupancy, and
    // using different divisors for offer pricing and the saved source quote would corrupt the total.
    if (!items.length || !isNonEmptyArray(rooms) || rooms.length !== items.length) return

    // LIMITATION: the price change only tells us the total, not the per-room split, so divide evenly.
    const [{ offerId, roomId, roomRateId, isFlightBundle, checkIn, checkOut }] = items
    dispatch(updateBedbankPricingData(offerId, roomId, roomRateId, isFlightBundle, checkIn, checkOut, rooms, {
      data: fillArray(rooms.length, () => ({
        inclusive: priceChange.newStandardPrice ? priceChange.newStandardPrice / rooms.length : undefined,
        memberInclusive: priceChange.newLuxPlusPrice ? priceChange.newLuxPlusPrice / rooms.length : undefined,
        // Unlike the prices above, zero is a legitimate new amount.
        propertyFees: priceChange.newPropertyFees === undefined ? undefined : priceChange.newPropertyFees / rooms.length,
      })),
    }))
    // A removed loyalty package upgrade prices its source rate from a saved quote that the offer-state
    // update does not change. Apply the accepted figures to that quote as well.
    for (const item of items) {
      const repricedItem = buildRepricedSourceItem(item, {
        price: priceChange.newStandardPrice || undefined,
        luxPlusPrice: priceChange.newLuxPlusPrice || undefined,
        propertyFees: priceChange.newPropertyFees,
        itemCount: items.length,
      })
      if (repricedItem !== item) dispatch(updateCheckoutItem(repricedItem))
    }
    dispatch(updateBedbankSession())
    trackCheckoutObservabilityEvent({
      subject: 'step', action: 'continuation_ready', type: 'interaction', scope: 'cart', canContinue: true,
    })
  }
}

/** Forfeit a rejected loyalty package upgrade by keeping the target rate without its discount. */
export function forfeitCheckoutLoyaltyPropertyRateUpgrade(
  item: App.Checkout.InstantBookingLEHotelItem | App.Checkout.BedbankHotelItem,
): AppAction {
  return (dispatch) => {
    dispatch(updateCheckoutItem(buildLoyaltyUpgradeForfeitedItem(item)))
  }
}

/**
 * Prevent repeated re-checks of the same loyalty package upgrade at the same repriced figures. A new
 * price receives a new check because it may satisfy margin validation. Cleared on page reload.
 */
const recheckedUpgradeKeys = new Set<string>()

function buildRecheckKey(itemId: string, reprice: { price?: number, luxplusPrice?: number, propertyFees?: number }): string {
  return `${itemId}:${reprice.price ?? ''}:${reprice.luxplusPrice ?? ''}:${reprice.propertyFees ?? ''}`
}

/** Maximum wait for refreshed rates before leaving the loyalty package upgrade removed. */
const RATES_REFRESH_TIMEOUT_MS = 10_000
const RATES_REFRESH_POLL_MS = 250

/**
 * Re-check a loyalty package upgrade after bedbank rejects its previous pricing.
 *
 * Refresh availability, match the source and target by stable service rate ids, then restore the
 * loyalty package upgrade and start a new enquiry if it still exists. Return refreshed pricing on
 * success or `undefined` when the upgrade cannot be restored.
 */
export function recheckPropertyRateUpgradeAfterPriceChange(
  snapshot: {
    item: App.Checkout.BedbankHotelItem,
    upgrade: App.Checkout.PropertyRateLoyaltyUpgrade,
    /** What bedbank repriced to, so a second, different reprice isn't mistaken for the same one. */
    reprice: { price?: number, luxplusPrice?: number, propertyFees?: number },
    /** False when refreshing a source rate the member deliberately selected after removing the upgrade. */
    restoreAppliedUpgrade?: boolean,
  },
): ThunkAction<Promise<RefreshedPropertyRateUpgrade | undefined>, App.State, undefined, DefinedAppAction> {
  return async(dispatch, getState): Promise<RefreshedPropertyRateUpgrade | undefined> => {
    const { item, upgrade, reprice, restoreAppliedUpgrade = true } = snapshot
    const recheckKey = buildRecheckKey(item.itemId, reprice)
    if (recheckedUpgradeKeys.has(recheckKey)) return undefined
    recheckedUpgradeKeys.add(recheckKey)

    const occupancies = item.occupancy ? [item.occupancy] : []
    const ratesKey = getPropertyRatesReduxKeys({
      propertyId: upgrade.target.propertyId,
      checkIn: item.checkIn,
      checkOut: item.checkOut,
      occupancies,
      utmContent: undefined,
      roomTypeId: undefined,
      roomRateId: undefined,
    })?.combined
    if (!ratesKey) return undefined

    dispatch(fetchPropertyRates(upgrade.target.propertyId, {
      checkIn: item.checkIn,
      checkOut: item.checkOut,
      occupancies,
      utmContent: undefined,
      roomTypeId: undefined,
      roomRateId: undefined,
      refresh: true,
    }))

    // TODO(LOYAL-2695): replace this poll with an awaited fetch. `fetchPropertyRates` dispatches an
    // `API_CALL`, and the middleware hands back the action rather than the promise, so there is
    // nothing to wait on. An `asyncFetchPropertyRates` alongside it — awaiting `getPropertyRates` and
    // dispatching the lifecycle actions itself — would remove this loop, its timeout, and the need to
    // reason about reducer internals here.
    const deadline = Date.now() + RATES_REFRESH_TIMEOUT_MS
    let rooms: Array<App.RawPropertyRoomRates> | undefined
    while (Date.now() < deadline) {
      const record = getState().offer.propertyRates[ratesKey]
      // Wait for the fetch to settle, not for `rooms` to appear: the reducer deliberately keeps the
      // previous rooms in place while fetching, so testing for them reads back the rates we already
      // had — the ones bedbank has just refused.
      if (record && !record.fetching) {
        if (record.error) return undefined
        rooms = record.rooms
        break
      }
      await new Promise<void>(resolve => { setTimeout(resolve, RATES_REFRESH_POLL_MS) })
    }

    const refreshed = findRefreshedPropertyRateUpgrade(upgrade, rooms)
    if (!refreshed) return undefined

    const current = getState().checkout.cart.items.find((cartItem) => cartItem.itemId === item.itemId)
    if (!current) return undefined

    if (!restoreAppliedUpgrade) {
      dispatch(updateCheckoutItem({
        ...current,
        loyaltyPropertyRateUpgrade: { ...upgrade, ...refreshed, applied: false },
      } as App.Checkout.BedbankHotelItem))
      return refreshed
    }

    // The loyalty package upgrade is available at the refreshed prices, so clear its rejection record.
    clearRejectedPropertyRateUpgrade({
      propertyId: upgrade.target.propertyId,
      sourceRateId: upgrade.source.serviceRateId,
      targetRateId: upgrade.target.serviceRateId,
      checkIn: item.checkIn,
      checkOut: item.checkOut,
      occupancy: item.occupancy,
    })

    dispatch(updateCheckoutItem({
      ...current,
      loyaltyAppliedUpgradeType: item.loyaltyAppliedUpgradeType,
      loyaltyBasePackageId: item.loyaltyBasePackageId,
      loyaltyBaseRateId: item.loyaltyBaseRateId,
      loyaltyPropertyRateUpgrade: { ...upgrade, ...refreshed },
    } as App.Checkout.BedbankHotelItem))
    const sessionUpdates: Array<BedbankSessionUpdateResult> = await dispatch(updateBedbankSession(item.itemId))
    const replacementSucceeded = sessionUpdates.some(({ itemIds, status }) =>
      status === 'success' && itemIds.includes(item.itemId),
    )
    return replacementSucceeded ? refreshed : undefined
  }
}
